import "./CaseView.css";
import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useMemo
} from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Select from "react-select";
import "react-tabs/style/react-tabs.css";
import Layout from "../../components/common/Layout";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Alerts from "../layout/Alerts";
import AlertContext from "../../context/alert/alertContext";
import DatePicker from "react-datepicker";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
//import StatusActive from "../../components/constants/StatusActive";
import checkTime from "../../components/constants/CheckTime"
import { format } from "date-fns"
import { faAlignCenter } from "@fortawesome/free-solid-svg-icons";
import { cp } from "fs";


const CaseView = props => {
  const handleSort = (column, sortDirection) => {
    setSortedColumn(column.selector);
    setSortDirection(sortDirection);
  };
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);    

  const pagePermission =
      JSON.parse(localStorage.getItem("permission")) === null
      ? {IsCreate: false,
        IsDelete: false,
        IsUpdate: false,
        IsView: false}
      : JSON.parse(localStorage.getItem("permission")).filter(c => parseInt(c.MenuId) === 3)[0];
  const Font = ReactQuill.Quill.import('formats/font');
  Font.whitelist = ['Arial', 'CordiaNew'];
  ReactQuill.Quill.register(Font,true);
  const alertContext = useContext(AlertContext);
  const { setAlert } = alertContext;
  const userId =
    JSON.parse(localStorage.getItem("user")) === null
      ? null
      : JSON.parse(localStorage.getItem("user"))[0].Id;
  const [classes_total, setClasses_total] = useState(0);
  const [classesList, setClassesList] = useState([]);
  const [selectTab, setSelectTab] = useState(0);
  const [namesDdl, setNamesDdl] = useState([]);
  const [eventsDdl, setEventsDdl] = useState([]);
  const [officenumbertypeDdl, setOfficenumbertypeDdl] = useState([]);
  const [selectedRelateRows, setSelectedRelateRows] = useState([]);
  const [selectedBillableRows, setSelectedBillableRows] = useState([]);
  const [selectedBillList, setSelectedBillList] = useState([]);

  const [selectedClassRows, setSelectedClassRows] = useState([]);

  const [annotationDel, setAnnotationDel] = useState();
  const [showKeepOnTop, setShowKeepOnTop] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [showConfirm, setShowConfirm] = useState({ showPop: false, part: "" });
  const [showDelete, setShowDelete] = useState({
    showPop: false,
    part: "",
    Id: ""
  });
  const [showCaseName, setShowCaseName] = useState(false);
  const [showCaseClass, setShowCaseClass] = useState({ showPop: false, caseClassId: "" });
  const [showClasses, setShowClasses] = useState(false);
  const [showCaseEvent, setshowCaseEvent] = useState({
    showPop: false,
    show: "",
    caseEventId: ""
  });
  const [showCaseOfficialNumber, setShowCaseOfficialNumber] = useState({
    showPop: false,
    show: "",
    caseOfficialNumberId: ""
  });
  const [showCaseDocument, setShowCaseDocument] = useState({
    showPop: false,
    show: "",
    caseDocumentId: ""
  });
  const [showDeleteDocument, setShowDeleteDocument] = useState({
    showPop: false,
    show: "",
    caseDocumentId: ""
  });
  const [showRelatedCase, setShowRelatedCase] = useState(false);
  const [showDeleteRelatedCase, setShowDeleteRelatedCase] = useState({
    showPop: false,
    part: "",
    Id: "",
    RefId : "",
  });
  const [showBillableCase, setShowBillableCase] = useState(false);

  const namesColumn = [
    {
      name: "Type",
      selector: "NamesTypeName",
      sortable: true,
      width: "125px",
      wrap: true
    },
    {
      cell: row => (
        <Link to={"/names/view/" + row.NamesId} target="_blank"> 
        {
          row.NamesName
            ? ( row.NamesName + 
              (
                row.Initial
                  ? ' (' + row.Initial + ')' 
                  : ''
              ) + 
              ' {' + row.NamesCode + '}') 
            : ''
        } 
        </Link>
      ),
      name: "Name",
      sortable: true,
      ignoreRowClick: false,
      allowOverflow: true,
      minWidth: "300px",
      wrap: true
    },
    // { 
    //   name: "Name",
    //   selector: "NamesName",
    //   sortable: true,
    //   width: "250px",
    //   wrap: true
    // },
    {
      name: "Attention",
      selector: "Attention",
      sortable: true,
      width: "250px",
      wrap: true
    },
    {
      name: "Reference",
      selector: "Reference",
      sortable: true,
      wrap: true
    }
  ];
  const [namesData, setNamesData] = useState([]);
  const classesColumn = [
    {
      name: "Class",
      selector: "ClassesCode",
      sortable: true,
      wrap: true,
      maxWidth: "5"
    },
    {
      name: "Text",
      selector: "ClassesTextEN",
      sortable: true,
      //width: "500px",
      grow: 2,
      wrap: true
    },
    {
      name: "TextTH",
      selector: "ClassesTextTH",
      sortable: true,
      grow: 2,
      //width: "500px",
      wrap: true
    },
    {
      name: "LastUpdateBy",
      selector: "LastUpdateBy",
      sortable: true,
      wrap: true,
      //width: "200px"
    },
    {
      name: "LastUpdateDateTime",
      selector: "LastUpdateDateTime",
      sortable: true,
      wrap: true
    }
  ];

  
  const eventsOpenning = [
    {
      cell: row => (
        <div>
          <button
            hidden={!pagePermission.IsUpdate}
            className="btn btn-sm btn-primary"
            onClick={() => {
              setshowCaseEvent({
                showPop: true,
                show: "Edit",
                caseEventId: row.CaseEventId
              });
            }}
          >
            <i className="fa fa-pencil"></i> Edit
          </button>
          <button
            className="btn btn-sm btn-danger ml-2"
            type="button"
            hidden={!pagePermission.IsDelete}
            onClick={() => {
              setShowDelete({ showPop: true, part: "event", Id: row.CaseEventId });
            }}
          >
            <i className="fa fa-remove"></i> Delete
          </button>
        </div>
      ),
      ignoreRowClick: false,
      allowOverflow: true,
      width: pagePermission.IsUpdate|| pagePermission.IsDelete ? "163px" : "0px",
      button: true
    },
    {
      name: "Event",
      selector: "EventsName",
      sortable: true,
      wrap: true
    },   
    {
      name: "Complete Date",
      selector: "CompleteDate",
      sortable: true,
      wrap: true,

      cell: row => (
        <div>
          {row.CompleteDate 
            ? format(new Date(row.CompleteDate), 'yyyy-MM-dd') 
            : row.OccurredDate 
              ? format(new Date(row.OccurredDate), 'dd-MMM-yyyy') 
              : ''}
        </div>)
    }
  ];
  const eventsSuccessColumn = [
    {
      cell: row => (
        <div>
          <button
            hidden={!pagePermission.IsUpdate}
            className="btn btn-sm btn-primary"
            onClick={() => {
              setshowCaseEvent({
                showPop: true,
                show: "Edit",
                caseEventId: row.CaseEventId
              });
            }}
          >
            <i className="fa fa-pencil"></i> Edit
          </button>
          <button
            className="btn btn-sm btn-danger ml-2"
            type="button"
            hidden={!pagePermission.IsDelete}
            onClick={() => {
              setShowDelete({ showPop: true, part: "event", Id: row.CaseEventId });
            }}
          >
            <i className="fa fa-remove"></i> Delete
          </button>
        </div>
      ),
      ignoreRowClick: false,
      allowOverflow: true,
      width: pagePermission.IsUpdate|| pagePermission.IsDelete ? "163px" : "0px",
      button: true
    },
    {
      name: "Event",
      selector: "EventsName",
      sortable: true,
      wrap: true,
      cell: row => (
        <div>
          {row.EventsName.includes('Other') && row.EventsRemark != ''
            ? row.EventsName + " (" + row.EventsRemark + ")"
            : row.EventsName 
          }
        </div>)
    },

    {
      name: "Complete Date",
      selector: "ActualCompleteDate",
      sortable: true,
      wrap: true,
      
      cell: row => (
        <div>
          { !row.CompleteDate 
            ? format(new Date(row.OccurredDate), 'dd-MMM-yyyy')
              :
              format(new Date(row.CompleteDate), 'yyyy') == 9999
                ? '-'
                : format(new Date(row.CompleteDate), 'dd-MMM-yyyy')
       }
        </div>)
        
    }
  ];
  const eventsNotyetColumn = [
    {
      cell: row => (
        <div>
          <button
            hidden={!pagePermission.IsUpdate}
            className="btn btn-sm btn-primary"
            onClick={() => {
              setshowCaseEvent({
                showPop: true,
                show: "Edit",
                caseEventId: row.CaseEventId
              });
            }}
          >
            <i className="fa fa-pencil"></i> Edit
          </button>
          <button
            className="btn btn-sm btn-danger ml-2"
            type="button"
            hidden={!pagePermission.IsDelete}
            onClick={() => {
              setShowDelete({ showPop: true, part: "event", Id: row.CaseEventId });
            }}
          >
            <i className="fa fa-remove"></i> Delete
          </button>
        </div>
      ),
      ignoreRowClick: false,
      allowOverflow: true,
      width: pagePermission.IsUpdate|| pagePermission.IsDelete ? "163px" : "0px",
      button: true
    },
    {
      name: "Event",
      selector: "EventsName",
      sortable: true,
      wrap: true
    },
    {
      name: "Start Date",
      selector: "StartDate",
      sortable: true,
      wrap: true,
      cell: row => (
        <div>
          {row.StartDate ? format(new Date(row.StartDate), 'dd-MMM-yyyy') : ''}
        </div>)
    },
    {
      cell: row => {
        if (new Date(row.DueDate) <= new Date()) {
          return <p style={{ color: "red" }}>{row.DueDate ? format(new Date(row.DueDate), 'dd-MMM-yyyy') : ''}</p>;
        } else {
          return <p>{row.DueDate ? format(new Date(row.DueDate), 'dd-MMM-yyyy') : ''}</p>;
        }
      },
      name: "Due Date",
      //selector: "DueDate",
      sortable: true,
      wrap: true
    }
  ];
  const officialNumbersColumn = [
    {
      cell: row => (
        <div>
          <button
            hidden={!pagePermission.IsUpdate}
            className="btn btn-sm btn-primary ml-2"
            type="button"
            onClick={() => {
              setShowCaseOfficialNumber({
                showPop: true,
                show: "Edit",
                caseOfficialNumberId: row.CaseOfficialNumberId
              });
            }}
          >
            <i className="fa fa-pencil"></i> Edit
          </button>
          {
            <button
               className="btn btn-sm btn-danger ml-2"
               type="button"
               onClick={() => {
                 setShowDelete({showPop: true, part: "OfficialNumber", Id: row.CaseOfficialNumberId });
               }}
             >
               <i className="fa fa-remove"></i> Delete
             </button>
          }
        </div>
      ),
      ignoreRowClick: false,
      allowOverflow: true,
      width: pagePermission.IsUpdate ? "180px" : "0px",
      button: true
    },
    {
      name: "Type",
      selector: "CaseOfficialNumberType",
      sortable: true,
      //width: "500px",
      wrap: true
    },
    {
      name: "Official No.",
      selector: "OfficialNo",
      sortable: true,
      wrap: true
    },
    {
      name: "Date In Force",
      selector: "DateInForce",
      sortable: true,
      wrap: true
    }
  ];
  const documentColumn = [
    {
      cell: row => (
        <div>
          <button
            className="btn btn-sm btn-primary ml-2"
            onClick={() => {
              window.open(
                process.env.REACT_APP_API_URL +
                  "/api/casedocumentsmap/download?caseDocumentId=" +
                  row.caseDocumentId
              );
            }}
          >
            <i className="fa fa-download"></i> Download
          </button>
          <button
            hidden={!pagePermission.IsDelete}
            className="btn btn-sm btn-danger ml-2"
            onClick={() => {
              setShowDeleteDocument({
                caseDocumentId: row.caseDocumentId,
                showPop: true
              });
            }}
          >
            <i className="fa fa-remove"></i> Delete
          </button>
        </div>
      ),
      ignoreRowClick: false,
      allowOverflow: true,
      width: "200px",
      button: true
    },
    {
      name: "File Name",
      selector: "fileNameOriginal",
      sortable: true,
      wrap: true
    },
    {
      name: "File Size",
      selector: "fileSize",
      sortable: true,
      wrap: true
    },
    {
      name: "LastUpdateBy",
      selector: "LastUpdateBy",
      sortable: true,
      wrap: true
    },
    {
      name: "LastUpdateDateTime",
      selector: "LastUpdateDateTime",
      sortable: true,
      wrap: true
    }
  ];
  const relatedCaseColumn = [
    // {
    //   name: "Relate By",
    //   selector: "RelateBy",
    //   sortable: true,
    //   wrap: true
    // },
    // {
    //   name: "Case Id",
    //   selector: "CaseId",
    //   sortable: true,
    //   wrap: true
    // },
    {
      cell: row => (

        row.RelateBy === "handle" && 
         (
        <div>
     
          {
            <button
               className="btn btn-sm btn-danger ml-2"
               type="button"
               onClick={() => {
                setShowDeleteRelatedCase({showPop: true, part: "RelatedCases", Id: row.CaseRefId, RefId : row.CaseId });
               }}
             >
               <i className="fa fa-remove"></i> Delete 
             </button>
          }
        </div>
        )
      ),
      ignoreRowClick: false,
      allowOverflow: true,
      width: pagePermission.IsUpdate ? "180px" : "0px",
      button: true
    },
    {
      name: "Case Reference",
      selector: "CaseReference",
      sortable: true,
      wrap: true
    },
    {
      cell: row => (
        <Link to={"/cases/view/" + row.CaseId} target="_blank" > {row.Title} </Link>
      ),
      name: "Title",
      //selector: "Title",
      ignoreRowClick: false,
      allowOverflow: true,
      sortable: true,
      wrap: true
    },
    {
      name: "Profit Centre",
      selector: "ProfitCentreName",
      sortable: true,
      wrap: true
    },
    {
      name: "Tax Treatment",
      selector: "TaxTreatmentName",
      sortable: true,
      wrap: true
    },
    {
      name: "Case Type",
      selector: "CaseTypeName",
      sortable: true,
      wrap: true
    },
    {
      name: "Case Status",
      selector: "CaseStatusName",
      sortable: true,
      cell: row => {
        switch (row.CaseStatusId) {
          case 3:
            return (
              <h6>
                <span className="badge badge-success text-left">
                  {row.CaseStatusName}
                </span>
              </h6>
            );
          case 1:
            return (
              <h6>
                <span className="badge badge-secondary text-left">
                  {row.CaseStatusName}
                </span>
              </h6>
            );
          case 2:
            return (
              <h6>
                <span className="badge badge-info text-left">
                  {row.CaseStatusName}
                </span>
              </h6>
            );
          case 4:
            return (
              <h6>
                <span className="badge badge-danger text-left">
                  {row.CaseStatusName}
                </span>
              </h6>
            );
          default:
            return <span>{row.CaseStatusName}</span>;
        }
      }
    },
    {
      name: "LastUpdateBy",
      selector: "LastUpdateBy",
      sortable: true,
      wrap: true,
      width: "200px"
    },
    {
      name: "LastUpdateDateTime",
      selector: "LastUpdateDateTime",
      sortable: true,
      wrap: true
    }
  ];
  const billableCaseColumn = [
    // {
    //   name: "Relate By",
    //   selector: "RelateBy",
    //   sortable: true,
    //   wrap: true
    // },
    // {
    //   name: "Case Id",
    //   selector: "CaseId",
    //   sortable: true,
    //   wrap: true
    // },
    {
      name: "Case Reference",
      selector: "CaseReference",
      sortable: true,
      wrap: true
    },
    {
      cell: row => (
        <Link to={"/cases/view/" + row.CaseId} target="_blank" > {row.Title} </Link>
      ),
      name: "Title",
      //selector: "Title",
      ignoreRowClick: false,
      allowOverflow: true,
      sortable: true,
      wrap: true
    },
    {
      name: "Profit Centre",
      selector: "ProfitCentreName",
      sortable: true,
      wrap: true
    },
    {
      name: "Tax Treatment",
      selector: "TaxTreatmentName",
      sortable: true,
      wrap: true
    },
    {
      name: "Case Type",
      selector: "CaseTypeName",
      sortable: true,
      wrap: true
    },
    {
      name: "Case Status",
      selector: "CaseStatusName",
      sortable: true,
      cell: row => {
        switch (row.CaseStatusId) {
          case 3:
            return (
              <h6>
                <span className="badge badge-success text-left">
                  {row.CaseStatusName}
                </span>
              </h6>
            );
          case 1:
            return (
              <h6>
                <span className="badge badge-secondary text-left">
                  {row.CaseStatusName}
                </span>
              </h6>
            );
          case 2:
            return (
              <h6>
                <span className="badge badge-info text-left">
                  {row.CaseStatusName}
                </span>
              </h6>
            );
          case 4:
            return (
              <h6>
                <span className="badge badge-danger text-left">
                  {row.CaseStatusName}
                </span>
              </h6>
            );
          default:
            return <span>{row.CaseStatusName}</span>;
        }
      }
    },
    {
      name: "LastUpdateBy",
      selector: "LastUpdateBy",
      sortable: true,
      wrap: true,
      width: "200px"
    },
    {
      name: "LastUpdateDateTime",
      selector: "LastUpdateDateTime",
      sortable: true,
      wrap: true
    }
  ];

  const relatedColumn = [
    {
    name: "Case Reference",
    selector: "CaseReference",
    sortable: true,
    wrap: true
  },
  {
    name: "Title",
    selector: "Title",
    sortable: true,
    wrap: true
  },
  {
    name: "Profit Centre",
    selector: "ProfitCentreName",
    sortable: true,
    wrap: true
  },
  {
    name: "Tax Treatment",
    selector: "TaxTreatmentName",
    sortable: true,
    wrap: true
  },
  {
    name: "Case Type",
    selector: "CaseTypeName",
    sortable: true,
    wrap: true
  },
  {
    name: "Case Status",
    selector: "CaseStatusName",
    sortable: true,
    cell: row => {
      switch (row.CaseStatusId) {
        case 3:
          return (
            <h6>
              <span className="badge badge-success text-left">
                {row.CaseStatusName}
              </span>
            </h6>
          );
        case 1:
          return (
            <h6>
              <span className="badge badge-secondary text-left">
                {row.CaseStatusName}
              </span>
            </h6>
          );
        case 2:
          return (
            <h6>
              <span className="badge badge-info text-left">
                {row.CaseStatusName}
              </span>
            </h6>
          );
        case 4:
          return (
            <h6>
              <span className="badge badge-danger text-left">
                {row.CaseStatusName}
              </span>
            </h6>
          );
        default:
          return <span>{row.CaseStatusName}</span>;
      }
    }
  },
  {
    name: "LastUpdateBy",
    selector: "LastUpdateBy",
    sortable: true,
    wrap: true
  },
  {
    name: "LastUpdateDateTime",
    selector: "LastUpdateDateTime",
    sortable: true,
    wrap: true
  }
];
  const billableColumn = [
    {
      cell: (row) => <button className="btn btn-dark" onClick={() => addToSelectedBillList(row.CaseId, row.CaseReference)}>Add</button>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
    name: "Case Reference",
    selector: "CaseReference",
    sortable: true,
    wrap: true
  },
  {
    name: "Title",
    selector: "Title",
    sortable: true,
    wrap: true
  },
  {
    name: "Profit Centre",
    selector: "ProfitCentreName",
    sortable: true,
    wrap: true
  },
  {
    name: "Tax Treatment",
    selector: "TaxTreatmentName",
    sortable: true,
    wrap: true
  },
  {
    name: "Case Type",
    selector: "CaseTypeName",
    sortable: true,
    wrap: true
  },
  {
    name: "Case Status",
    selector: "CaseStatusName",
    sortable: true,
    cell: row => {
      switch (row.CaseStatusId) {
        case 3:
          return (
            <h6>
              <span className="badge badge-success text-left">
                {row.CaseStatusName}
              </span>
            </h6>
          );
        case 1:
          return (
            <h6>
              <span className="badge badge-secondary text-left">
                {row.CaseStatusName}
              </span>
            </h6>
          );
        case 2:
          return (
            <h6>
              <span className="badge badge-info text-left">
                {row.CaseStatusName}
              </span>
            </h6>
          );
        case 4:
          return (
            <h6>
              <span className="badge badge-danger text-left">
                {row.CaseStatusName}
              </span>
            </h6>
          );
        default:
          return <span>{row.CaseStatusName}</span>;
      }
    }
  },
  {
    name: "LastUpdateBy",
    selector: "LastUpdateBy",
    sortable: true,
    wrap: true
  },
  {
    name: "LastUpdateDateTime",
    selector: "LastUpdateDateTime",
    sortable: true,
    wrap: true
  }
];

  const [classesData, setClassesData] = useState([]);
  const [classesMasData, setClassesMasData] = useState([]);
  const classForMap = useMemo(() => classesMasData, [classesMasData]);
  const [eventsOpenningData, setEventsOpenningData] = useState([]);
  const [eventsSuccessData, setEventsSuccessData] = useState([]);
  const customSort = (rows, selector, direction) => {
    return rows.sort((rowA, rowB) => {
     // use the selector function to resolve your field names by passing the sort comparitors
     const aField = typeof selector === 'function' ? selector(rowA) : rowA[selector];      
     const bField = typeof selector === 'function' ? selector(rowB) : rowB[selector];
   
     let comparison = 0;
   
     if (aField > bField) {
      comparison = 1;
     } else if (aField < bField) {
      comparison = -1;
     }
   
     return direction === 'desc' ? comparison * -1 : comparison;
    });
   };
  const [eventsNotyetData, setEventsNotyetData] = useState([]);
  const [officialNumbersData, setOfficialNumbersData] = useState([]);
  const [documentData, setDocumentData] = useState([]);
  const [relatedCaseData, setRelatedCaseData] = useState([]);
  const [billableCaseData, setBillableCaseData] = useState([]);
  const [relatedCaseModalData, setRelatedCaseModalData] = useState([]);
  const [billableCaseModalData, setBillableCaseModalData] = useState([]);
  const [caseTypeDdl, setCaseTypeDdl] = useState([]);
  const [basisDdl, setBasisDdl] = useState([]);
  const [typeOfMarkDdl, setTypeOfMarkDdl] = useState([]);
  const [RelateSearchFormData, setRelateSearchFormData] = useState({
    title : '',
    caseReference: '',
    caseType : { value: 0, label: "Select All" },
    basis : { value: 0, label: "Select All" },
    typeOfMark : { value: 0, label: "Select All" },
  });
  const [BillableSearchFormData, setBillableSearchFormData] = useState({
    title : '',
    caseReference: '',
    caseType : { value: 0, label: "Select All" },
    basis : { value: 0, label: "Select All" },
    typeOfMark : { value: 0, label: "Select All" },
  });
  const filterRelateCase = (dataa) => {
    return dataa.filter((data) => {
      return (
        ((RelateSearchFormData.typeOfMark.value === 0) 
          || ( parseInt(data.typeOfMarkId) === parseInt(RelateSearchFormData.typeOfMark.value))) 
        && 
        ((RelateSearchFormData.caseType.value === 0) 
          || ( parseInt(data.caseTypeId) === parseInt(RelateSearchFormData.caseType.value))) 
        &&
        ((RelateSearchFormData.basis.value === 0) 
          || (parseInt(data.basisId) === parseInt(RelateSearchFormData.basis.value))) 
        &&
        (data.Title.toLowerCase().includes(RelateSearchFormData.title.toLowerCase())) 
        &&
        (data.CaseReference.toLowerCase().includes(RelateSearchFormData.caseReference.toLowerCase()))
    )})
  }
  const filterBillableCase = (dataa) => {
    return dataa.filter((data) => {
      return (
        ((BillableSearchFormData.typeOfMark.value === 0) 
          || ( parseInt(data.typeOfMarkId) === parseInt(BillableSearchFormData.typeOfMark.value))) 
        && 
        ((BillableSearchFormData.caseType.value === 0) 
          || ( parseInt(data.caseTypeId) === parseInt(BillableSearchFormData.caseType.value))) 
        &&
        ((BillableSearchFormData.basis.value === 0) 
          || (parseInt(data.basisId) === parseInt(BillableSearchFormData.basis.value))) 
        &&
        (data.Title.toLowerCase().includes(BillableSearchFormData.title.toLowerCase())) 
        &&
        (data.CaseReference.toLowerCase().includes(BillableSearchFormData.caseReference.toLowerCase()))
    )})
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const caseForRelatedData = useMemo(() => filterRelateCase(relatedCaseModalData), [filterRelateCase(relatedCaseModalData)]);
  const caseForBillableData = useMemo(() => filterBillableCase(billableCaseModalData), [filterBillableCase(billableCaseModalData)]);

  const [caseFormData, setCaseFormData] = useState({
    CaseReference: "",
    Title: "",
    Family: "",
    CaseTypeId: "",
    CaseTypeName: "",
    CaseOfficeName: "",
    CountryName: "",
    TypeOfMarkName: "",
    BasisName: "",
    NoInSeries: "",
    CaseStatusName: "",
    KeepOnTopNote: ""
  });
  const [namesFormData, setNamesFormData] = useState({
    Instructor: {caseNameId: 0, namesId: "", namesName: "", attention: "", reference: ""},
    Debtor: {caseNameId: 0, namesId: "", namesName: "", attention: "", reference: ""},
    Owner: {caseNameId: 0, namesId: "", namesName: "", attention: "", reference: ""},
    Agent: {caseNameId: 0, namesId: "", namesName: "", attention: "", reference: ""},
    Refferal: {caseNameId: 0, namesId: "", namesName: "", attention: "", reference: ""},
    Partner: {caseNameId: 0, namesId: "", namesName: "", attention: "", reference: ""},
    Attorney: {caseNameId: 0, namesId: "", namesName: "", attention: "", reference: ""},
    Executive: {caseNameId: 0, namesId: "", namesName: "", attention: "", reference: ""},
    createBy: userId
  });

  const [classFormData, setClassFormData] = useState({
    caseClassId: 0,
    caseId: props.match.params.id,
    classesId: 0,
    classesCode: "",
    classesTextTH: "",
    classesTextEN: "",
    createBy: userId
  });
  const [eventFormData, setEventFormData] = useState({
    caseId: props.match.params.id,
    eventId: 0,
    eventName: "",
    eventRemark: "",
    occurredDate : new Date(),
    startDate: null,
    dueDate: null,
    completeDate: null,
    createBy: userId,
    hasDeadLine: 0
  });

  const [tempImgTrademarkData, setTempImgTrademarkData] = useState("");

  const [imgFormData, setImgFormData] = useState({
    caseImageId: 0,
    caseId: props.match.params.id,
    filePath: "",
    fileName: "",
    fileNameOriginal: "",
    imgBase64: "",
    createBy: userId
  });

  const [tempDocumentData, setTempDocumentData] = useState("");

  const [officialNumberFormData, setOfficialNumberFormData] = useState({
    caseId: props.match.params.id,
    officialNumberTypeId: 0,
    caseOfficialNumberType: "",
    officialNo: "",
    dateInForce: null,
    createBy: userId
  });
  const [sendEmailFormData, setSendEmailFormData] = useState({
    toTxt: "",
    ccTxt: "",
    bccTxt: "",
    subjectTxt: "",
    bodyTxt: "",
    createBy: userId,
    emailSender: JSON.parse(localStorage.getItem("user")) === null ? null
      : JSON.parse(localStorage.getItem("user"))[0].EmailAddress
  })

/*
  const customSort = (rows, selector, direction) => {
    return rows.sort((rowA, rowB) => {
      // use the selector function to resolve your field names by passing the sort comparitors
      if(selector === 'CompleteDate')
      {
        const aField = typeof selector === 'function' ? selector(rowA) : rowA['CompleteDate']
        ?  rowA['CompleteDate']
        : rowA['OccurredDate']  ? rowA['OccurredDate']  : '';

        const bField = typeof selector === 'function' ? selector(rowB) : rowB['CompleteDate']
        ?  rowB['CompleteDate']
        : rowB['OccurredDate']  ? rowB['OccurredDate']  : '';
        let comparison = 0;
    
        if (aField > bField) {
         comparison = 1;
        } else if (aField < bField) {
         comparison = -1;
        }

        console.log((direction) + aField + " : " + bField + " : " + (direction === 'desc' ? comparison * -1 : comparison));
  
        return direction === 'desc' ? comparison * -1 : comparison;
      }
      else
      {
        const aField = typeof selector === 'function' ? selector(rowA) : rowA[selector];      
        const bField = typeof selector === 'function' ? selector(rowB) : rowB[selector];
        let comparison = 0;
    
        if (aField > bField) {
          comparison = 1;
        } else if (aField < bField) {
          comparison = -1;
        }
        console.log(aField + " : " + bField + " : " + (direction === 'desc' ? comparison * -1 : comparison));
      
        return direction === 'desc' ? comparison * -1 : comparison;
      }
        

     });
   };
*/
  const getFileSelect = e => {
    if (
      e.target.files.length > 0 &&
      !e.target.files[0].name.match(/\.(jpg|jpeg|png|gif|bmp|ico|svg)$/)
    ) {
      e.target.value = null;
      alert(
        "Please select only image file (.jpg, .jpeg, .png, .gif, .bmp, .ico, .svg)"
      );
    } else {
      setTempImgTrademarkData(e.target.files[0]);
    }
  };

  const getDocumentSelect = e => {
    setTempDocumentData(e.target.files[0]);
  };

  const reloadNames = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "/api/casenamesmap/", {
        params: { caseId: props.match.params.id }
      })
      .then(res => {
        setNamesData(res.data);
      });
  };
  const reloadClasses = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "/api/caseclassesmap/", {
        params: { caseId: props.match.params.id }
      })
      .then(res => {
        setClassesData(res.data);
        setClasses_total(res.data.length);
        setClassesList(res.data.map(x => x.ClassesCode));
      });
  };
  const reloadImages = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "/api/caseimagesmap", {
        params: { caseId: props.match.params.id }
      })
      .then(res => {
        //setImgFormData(res.data[0]);
        if(res.data[0] && res.data[0].filePath !== ""){
          toDataURL( window.location.origin + '/images/uploads/' + res.data[0].filePath , function(dataUrl){
            setImgFormData({...res.data[0], imgBase64: '<img src="'+ dataUrl + '">'});
          })
        }
      });
  };
  const reloadEvent = async () => {
    axios
      .get(process.env.REACT_APP_API_URL + "/api/caseeventmap/", {
        params: { caseId: props.match.params.id }
      })
      .then(res => {
        setEventsOpenningData(
          res.data.filter(function(data) {
            if (data.EventsName.includes('Case Open')) {
              return data.CompleteDate !== null || !data.HasDeadLine;
            }
          })
        );
        setEventsSuccessData(
          res.data
          .sort((a, b) => {
            if (a.ActualCompleteDate < b.ActualCompleteDate) {
              return -1; 
            } else {
              return 1; 
            }
          })
          .filter(function(data) {
            if (!data.EventsName.includes('Case Open')) {
              return data.CompleteDate !== null || !data.HasDeadLine;
            }          
          })
        );
        setEventsNotyetData(
          res.data
          .sort((a, b) => {
            if (a.DueDate < b.DueDate) {
              return -1; 
            } else {
              return 1; 
            }
          })
          .filter(function(data) {
            return data.CompleteDate === null && data.HasDeadLine;
          })
        );
      });
  };
  const reloadOfficialNumber = async () => {
    axios
      .get(process.env.REACT_APP_API_URL + "/api/caseofficialnumbermap/", {
        params: { caseId: props.match.params.id }
      })
      .then(res => {
        setOfficialNumbersData(res.data);
      });
  };
  const reloadDocument = async () => {
    axios
      .get(process.env.REACT_APP_API_URL + "/api/casedocumentsmap", {
        params: { caseId: props.match.params.id }
      })
      .then(res => {
        setDocumentData(res.data);
      });
  };
  const reloadRelatedCase = async (family, caseReference) => {
    axios
      .get(process.env.REACT_APP_API_URL + "/api/caserelatedcasemap/", {
        params: { caseId: props.match.params.id, family: family, caseReference: caseReference }
      })
      .then(res => {
        setRelatedCaseData(res.data);
      });
  };
  const reloadBillableCase = async (family, caseReference) => {
    console.log('reloadBillableCase');
    axios
      .get(process.env.REACT_APP_API_URL + "/api/casebillablecasemap/", {
        params: { caseId: props.match.params.id, family: family, caseReference: caseReference }
      })
      .then(res => {
        setBillableCaseData(res.data);
      });
  };
  const reloadCaseDetail = async (first) => {
    axios
      .get(
        process.env.REACT_APP_API_URL + "/api/cases/" + props.match.params.id
      )
      .then(res => {
        setCaseFormData(res.data[0]);
        if (first && res.data[0].KeepOnTopNote !== "") {
          setShowKeepOnTop(true);
        }
      });
  };

  useEffect(() => {
    if (sortedColumn && sortDirection) {
      console.log(`DataTable is sorted by column: ${sortedColumn} in ${sortDirection} order.`);
    }
  }, [sortedColumn, sortDirection]);

  useEffect(() => {
    checkTime();
    document.addEventListener("mousedown",  (e) => { checkTime() });
    reloadCaseDetail(1);
    reloadNames();
    setSelectTab(0);
    reloadImages();
    //Load Names DDL
    axios
      .get(process.env.REACT_APP_API_URL + "/api/names/ddl/getDDL")
      .then(res => {
        setNamesDdl([...namesDdl, ...res.data]);
      });
    //eslint-disable-next-line
  }, [, props.match.params.id]);
  useEffect(() => {
    //**** set or reset case names from data (in modal)
    if (showCaseName) {
      //Load Modal Case Names Map
      axios
      .get(process.env.REACT_APP_API_URL + "/api/casenamesmap/", {
        params: { caseId: props.match.params.id }
      })
        .then(res => {
          setNamesFormData({
            Instructor: {caseNameId: res.data[0].CaseNameId, 
              namesId: res.data[0].NamesId,
              namesName: res.data[0].NamesName ? (res.data[0].NamesName +
                                                  "{" + res.data[0].NamesCode + "}"
                                                ) : "",
              attention: res.data[0].Attention,
              reference: res.data[0].Reference},
            Debtor: {caseNameId: res.data[1].CaseNameId,
              namesId: res.data[1].NamesId, 
              namesName: res.data[1].NamesName ? (res.data[1].NamesName +
                                                  "{" + res.data[1].NamesCode + "}"
                                                ) : "",
              attention: res.data[1].Attention,
              reference: res.data[1].Reference},
            Owner: {caseNameId: res.data[2].CaseNameId,
              namesId: res.data[2].NamesId, 
              namesName: res.data[2].NamesName ? (res.data[2].NamesName +
                                                  "{" + res.data[2].NamesCode + "}"
                                                ) : "",
              attention: res.data[2].Attention,
              reference: res.data[2].Reference},
            Agent: {caseNameId: res.data[3].CaseNameId,
              namesId: res.data[3].NamesId, 
              namesName: res.data[3].NamesName ? (res.data[3].NamesName +
                                                  "{" + res.data[3].NamesCode + "}"
                                                ) : "",
              attention: res.data[3].Attention,
              reference: res.data[3].Reference},
            Refferal: {caseNameId: res.data[4].CaseNameId,
              namesId: res.data[4].NamesId, 
              namesName: res.data[4].NamesName ? (res.data[4].NamesName +
                                                  "{" + res.data[4].NamesCode + "}"
                                                ) : "",
              attention: res.data[4].Attention,
              reference: res.data[4].Reference},
            Partner: {caseNameId: res.data[5].CaseNameId,
              namesId: res.data[5].NamesId, 
              namesName: res.data[5].NamesName ? (res.data[5].NamesName +
                                                  "{" + res.data[5].NamesCode + "}"
                                                ) : "",
              attention: res.data[5].Attention,
              reference: res.data[5].Reference},
            Attorney: {caseNameId: res.data[6].CaseNameId,
              namesId: res.data[6].NamesId, 
              namesName: res.data[6].NamesName ? (res.data[6].NamesName +
                                                  "{" + res.data[6].NamesCode + "}"
                                                ) : "",
              attention: res.data[6].Attention,
              reference: res.data[6].Reference},
            Executive: {caseNameId: res.data[7].CaseNameId,
              namesId: res.data[7].NamesId, 
              namesName: res.data[7].NamesName ? (res.data[7].NamesName +
                                                  "{" + res.data[7].NamesCode + "}"
                                                ) : "",
              attention: res.data[7].Attention,
              reference: res.data[7].Reference},
            createBy: userId
          });
        });
    } else {
      setNamesFormData({
        Instructor: {caseNameId: 0, namesId: "", namesName: "", attention: "", reference: ""},
        Debtor: {caseNameId: 0, namesId: "", namesName: "", attention: "", reference: ""},
        Owner: {caseNameId: 0, namesId: "", namesName: "", attention: "", reference: ""},
        Agent: {caseNameId: 0, namesId: "", namesName: "", attention: "", reference: ""},
        Refferal: {caseNameId: 0, namesId: "", namesName: "", attention: "", reference: ""},
        Partner: {caseNameId: 0, namesId: "", namesName: "", attention: "", reference: ""},
        Attorney: {caseNameId: 0, namesId: "", namesName: "", attention: "", reference: ""},
        Executive: {caseNameId: 0, namesId: "", namesName: "", attention: "", reference: ""},
        createBy: userId
      });
    }
    //eslint-disable-next-line
  }, [showCaseName]);
  useEffect(() => {
    if (!showCaseClass.showPop) {
      setClassFormData({
        caseClassId: 0,
        caseId: props.match.params.id,
        classesId: 0,
        classesCode: "",
        classesTextTH: "",
        classesTextEN: "",
        createBy: userId
      });
    } else {
      axios
        .get(
          process.env.REACT_APP_API_URL +
            "/api/caseclassesmap/" +
            showCaseClass.caseClassId
        )
        .then(res => {
          setClassFormData({
            ...classFormData,
            caseClassId: res.data[0].CaseClassId,
            classesId: res.data[0].ClassesId,
            classesCode: res.data[0].ClassesCode,
            classesTextTH: res.data[0].ClassesTextTH,
            classesTextEN: res.data[0].ClassesTextEN
          });
        });
    }
    //eslint-disable-next-line
  }, [showCaseClass]);
  useEffect(() => {
    if (
      showCaseEvent.caseEventId === "" ||
      showCaseEvent.show === "Add"
    ) {
      setEventFormData({
        caseId: props.match.params.id,
        eventId: 0,
        eventName: "",
        eventRemark: "",
        occurredDate : new Date(),
        startDate: null,
        dueDate: null,
        completeDate: null,
        createBy: userId,
        hasDeadLine: 0
      });
    } else {
      axios
        .get(
          process.env.REACT_APP_API_URL +
            "/api/caseeventmap/" +
            showCaseEvent.caseEventId
        )
        .then(res => {
          setEventFormData({
            ...eventFormData,
            eventId: res.data[0].EventId,
            eventName: res.data[0].EventsName,
            eventRemark: res.data[0].EventsRemark,
            occurredDate: res.data[0].OccurredDate === null
            ? null
            : new Date(res.data[0].OccurredDate),
            startDate: res.data[0].StartDate === null
              ? null
              : new Date(res.data[0].StartDate),
            dueDate: res.data[0].DueDate === null
                ? null
                : new Date(res.data[0].DueDate),
            hasDeadLine: res.data[0].HasDeadLine,
            completeDate:
              res.data[0].CompleteDate === null
                ? null
                : new Date(res.data[0].CompleteDate)
          });
        });
    }
    //eslint-disable-next-line
  }, [showCaseEvent]);
  useEffect(() => {
    if (
      showCaseOfficialNumber.caseOfficialNumberId === "" ||
      showCaseOfficialNumber.show === "Add"
    ) {
      setOfficialNumberFormData({
        caseId: props.match.params.id,
        officialNumberTypeId: 0,
        caseOfficialNumberType: "",
        officialNo: "",
        dateInForce: null,
        createBy: userId
      });
    } else {
      axios
        .get(
          process.env.REACT_APP_API_URL +
            "/api/caseofficialnumbermap/" +
            showCaseOfficialNumber.caseOfficialNumberId
        )
        .then(res => {
          setOfficialNumberFormData({
            caseId: props.match.params.id,
            officialNumberTypeId: res.data[0].OfficialNumberTypeId,
            caseOfficialNumberType: res.data[0].CaseOfficialNumberType,
            officialNo: res.data[0].OfficialNo,
            dateInForce:
              res.data[0].DateInForce === null
                ? null
                : new Date(res.data[0].DateInForce),
            createBy: userId
          });
        });
    }
    //eslint-disable-next-line
  }, [showCaseOfficialNumber]);
  useEffect(() => {
    if(showRelatedCase){
      axios.get(process.env.REACT_APP_API_URL + "/api/casetype/ddl").then(res => {
        setCaseTypeDdl([...caseTypeDdl, ...res.data]);
      });
      axios.get(process.env.REACT_APP_API_URL + "/api/basis/ddl").then(res => {
        setBasisDdl([...basisDdl, ...res.data]);
      });
      axios
        .get(process.env.REACT_APP_API_URL + "/api/typeofmark/ddl")
        .then(res => {
          setTypeOfMarkDdl([...typeOfMarkDdl, ...res.data]);
        });
    } else {
      setRelateSearchFormData({
        title : '',
        caseReference: '',
        caseType : { value: 0, label: "Select All" },
        basis : { value: 0, label: "Select All" },
        typeOfMark : { value: 0, label: "Select All" },
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[showRelatedCase]);

  useEffect(() => {
    if(showBillableCase){
      axios.get(process.env.REACT_APP_API_URL + "/api/casetype/ddl").then(res => {
        setCaseTypeDdl([...caseTypeDdl, ...res.data]);
      });
      axios.get(process.env.REACT_APP_API_URL + "/api/basis/ddl").then(res => {
        setBasisDdl([...basisDdl, ...res.data]);
      });
      axios
        .get(process.env.REACT_APP_API_URL + "/api/typeofmark/ddl")
        .then(res => {
          setTypeOfMarkDdl([...typeOfMarkDdl, ...res.data]);
        });
    } else {
      setBillableSearchFormData({
        title : '',
        caseReference: '',
        caseType : { value: 0, label: "Select All" },
        basis : { value: 0, label: "Select All" },
        typeOfMark : { value: 0, label: "Select All" },
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[showBillableCase]);


  const saveEditCaseNames = () => {
    axios
      .put(
        process.env.REACT_APP_API_URL +
          "/api/casenamesmap/" +
          props.match.params.id,
        namesFormData
      )
      .then(res => {
        setShowConfirm({ showPop: false, part: "" });
        if (res.data.status === "0") {
          setAlert(res.data.msg, "success");
          setShowCaseName(false);
          reloadNames();
          setShowConfirm({ showPop: false, part: "" });
        } else {
          setAlert(res.data.msg, "danger");
          setShowConfirm({ showPop: false, part: "" });
        }
      });
  };
  const saveCaseClass = (action) => {
    if (action === "Add") {
      axios
        .post(
          process.env.REACT_APP_API_URL + "/api/caseclassesmap",
          {caseId: props.match.params.id, classIdList :selectedClassRows, createBy: userId}
        )
        .then(res => {
          submitSave(res);
        });
    } else if (action === "Edit") {
      axios
        .put(
          process.env.REACT_APP_API_URL +
            "/api/caseclassesmap/" +
            classFormData.caseClassId,
          classFormData
        )
        .then(res => {
          submitSave(res);
        });
    }
    const submitSave = res => {
      if (res.data.status === "0") {
        setAlert(res.data.msg, "success");
        //
        action === "Add"? setShowClasses(false): setShowCaseClass({ showPop: false, caseClassId: "" });
        reloadClasses();
        setShowConfirm({ showPop: false, part: "" });
      } else {
        setAlert(res.data.msg, "danger");
        setShowConfirm({ showPop: false, part: "" });
      }
    };
  };
  const saveCaseEvent = () => {
    if(parseInt(eventFormData.eventId) === 0){
      setAlert("Please select", "warning");
      setShowConfirm({ showPop: false, part: "" });
    }else if ( eventFormData.hasDeadLine > 0 && eventFormData.startDate === null ) {
      setAlert("Start Date is null! Please fill", "warning");
      setShowConfirm({ showPop: false, part: "" });
    }else if (eventFormData.hasDeadLine > 0 && eventFormData.dueDate === null) {
      setAlert("Due Date is null! Please fill", "warning");
      setShowConfirm({ showPop: false, part: "" });
    } else {
      if (showCaseEvent.show === "Add") {
        //console.log('Remark A : ' + eventFormData.eventRemark);
        axios
          .post(
            process.env.REACT_APP_API_URL + "/api/caseeventmap",
            eventFormData
          )
          .then(res => {
            submitSave(res);
            if(eventFormData.eventId === 46)
            {
              reloadCaseDetail(0);
            }

          });
      } else if (showCaseEvent.show === "Edit") {
        //console.log('Remark E : ' + eventFormData.eventRemark);

        axios
          .put(
            process.env.REACT_APP_API_URL +
              "/api/caseeventmap/" +
              showCaseEvent.caseEventId,
            eventFormData
          )
          .then(res => {
            submitSave(res);
          });
      }
    }

    const submitSave = res => {
      if (res.data.status === "0") {
        setAlert(res.data.msg, "success");
        if (eventFormData.eventId === 30){
          reloadCaseDetail(0);
        }
        setshowCaseEvent({
          howPop: false,
          show: "",
          caseEventId: ""
        });
        reloadEvent();
        setShowConfirm({ showPop: false, part: "" });
      } else {
        setAlert(res.data.msg, "danger");
        setShowConfirm({ showPop: false, part: "" });
      }
    };
  };
  const saveOfficialNumber = () => {
    if( parseInt(officialNumberFormData.officialNumberTypeId) === 0 ){
      setAlert("Please select", "warning");
      setShowConfirm({ showPop: false, part: "" });
    } else if (showCaseOfficialNumber.show === "Add") {
      axios
        .post(
          process.env.REACT_APP_API_URL + "/api/caseofficialnumbermap",
          officialNumberFormData
        )
        .then(res => {
          submitSave(res);
        });
    } else if (showCaseOfficialNumber.show === "Edit") {
      axios
        .put(
          process.env.REACT_APP_API_URL +
            "/api/caseofficialnumbermap/" +
            showCaseOfficialNumber.caseOfficialNumberId,
          officialNumberFormData
        )
        .then(res => {
          submitSave(res);
        });
    }
    const submitSave = res => {
      if (res.data.status === "0") {
        setAlert(res.data.msg, "success");
        setShowCaseOfficialNumber({
          showPop: false,
          show: "",
          caseOfficialNumberId: ""
        });
        reloadOfficialNumber();
        if(res.data.txtStatus !== ""){
          setCaseFormData({...caseFormData, CaseStatusName: res.data.txtStatus});
        }
        setShowConfirm({ showPop: false, part: "" });
      } else {
        setAlert(res.data.msg, "danger");
        setShowConfirm({ showPop: false, part: "" });
      }
    };
  };
  const saveRelatedCases = () => {
    axios
      .post(
        process.env.REACT_APP_API_URL + "/api/caserelatedcasemap",
        { caseId : props.match.params.id, caseRefIdList: selectedRelateRows.toString(), createBy: userId }
      )
      .then(res => {
        if (res.data.status === "0") {
          setAlert(res.data.msg, "success");
          setShowRelatedCase(false);
          reloadRelatedCase(caseFormData.Family, caseFormData.CaseReference);
          setShowConfirm({ showPop: false, part: "" });
        } else {
          setAlert(res.data.msg, "danger");
          setShowConfirm({ showPop: false, part: "" });
        }
      });
  };

  const saveBillableCases = () => {
    console.log("saveBillableCases");
    console.log("1. " + props.match.params.id);
    console.log("2.1 " + stripeCaseRef(selectedBillList.toString()));
    console.log("2.2 " + selectedBillList.toString());

    console.log("3. " + userId);

    
    axios
      .post(
        process.env.REACT_APP_API_URL + "/api/casebillablecasemap",
        { caseId : props.match.params.id, caseBillIdList: stripeCaseRef(selectedBillList.toString()), createBy: userId }
      )
      .then(res => {
        console.log(res.data.status + " : "+ res.data.msg);
        if (res.data.status === "0") {          
          setAlert(res.data.msg, "success");          
          setShowBillableCase(false);
          reloadBillableCase(caseFormData.Family, caseFormData.CaseReference);
          setShowConfirm({ showPop: false, part: "" });          
        } else {          
          setAlert(res.data.msg, "danger");
          setShowConfirm({ showPop: false, part: "" });          
        }
      });
      
  };
  const saveSendEmail = () => {
    console.log(sendEmailFormData);
    /*axios
      .post(
        process.env.REACT_APP_API_URL + "/api/manualsendmailbycase", 
        sendEmailFormData
      )
      .then(res => {
        if (res.data.status === "0") {
          setAlert(res.data.msg, "success");
          setShowEmail(false);
          setShowConfirm({ showPop: false, part: "" });
        } else {
          setAlert(res.data.msg, "danger");
          setShowConfirm({ showPop: false, part: "" });
        }
      });*/
  };

  const onChangeClasses = e =>
    setClassFormData({ ...classFormData, [e.target.name]: e.target.value });

  const selectRelateChange = useCallback(state => {
    setSelectedRelateRows(state.selectedRows.map(x => parseInt(x.CaseId, 10) ));
  }, []);

/* Billable */
  const removeTag = (idToRemove) => {
    setSelectedBillList(selectedBillList.filter(id => id !== idToRemove));
  };
  const addToSelectedBillList = useCallback((CaseId, CaseReference) => {
    var handleData = CaseId + ":" + CaseReference;
    setSelectedBillList(prevList => {
      // ตรวจสอบว่า CaseId นี้อยู่ใน list แล้วหรือไม่
      if (!prevList.includes(handleData)) {
        return [...prevList, handleData]; // เพิ่ม CaseId หากไม่มีใน list
      }
      return prevList; // ไม่เพิ่มหากมีอยู่แล้ว
    });
  }, []);

  const selectBillableChange = useCallback(({ allSelected, selectedCount, selectedRows  }) => {
    const ids = selectedRows.map(row => parseInt(row.CaseId, 10));
    console.log('allSelected : selectedCount | ' + allSelected + " : " + selectedCount);
    //setSelectedBillableRows(selectedRows.map(x => parseInt(x.CaseId, 10) ));
    setSelectedBillableRows(ids);

    
    setSelectedBillList(prevIds => {
      const allSelectedIds = new Set([...prevIds, ...ids]);
      console.log('allSelectedIds : ' +   console.log("All Selected IDs:", Array.from(allSelectedIds)));
      return Array.from(allSelectedIds);
    });
    
    const allSelectedIds = new Set([...ids]);
    //setSelectedBillList(ids);
    
    console.log("All Selected IDs:", Array.from(allSelectedIds));


    console.log('s1 : ' + selectedBillableRows);
    console.log('s2 : ' + selectedBillList);

  }, []);

  const isRowSelected = useCallback(row => {
    //console.log('CaseId : ' + parseInt(row.CaseId, 10) + row.selected);
    return row && row.CaseId && selectedBillableRows.includes(parseInt(row.CaseId, 10));
  }, [selectedBillableRows]);
  
  
  const selectClassChange = useCallback(state => {
    setSelectedClassRows(state.selectedRows.map(x => parseInt(x.ClassesId, 10) ));
  }, []);

  const onImgSubmit = e => {
    e.preventDefault();
    var fd = new FormData();
    fd.append("caseId", props.match.params.id);
    fd.append("caseReference", caseFormData.CaseReference);
    fd.append("createBy", userId);
    fd.append("avatar", tempImgTrademarkData);

    if (imgFormData && imgFormData.caseImageId > 0) {
      axios({
        method: "put",
        url:
          process.env.REACT_APP_API_URL +
          "/api/caseimagesmap/" +
          imgFormData.caseImageId,
        data: fd
      })
        .then(res => {
          if (res.data.status === "0") {
            setAlert(res.data.msg, "success");
            reloadImages();
          } else {
            setAlert(res.data.msg, "danger");
          }
        })
        .catch(e => {
          console.error(e);
        });
    } else {
      axios({
        method: "post",
        url: process.env.REACT_APP_API_URL + "/api/caseimagesmap",
        data: fd
      })
        .then(res => {
          if (res.data.status === "0") {
            setAlert(res.data.msg, "success");
            reloadImages();
          } else {
            setAlert(res.data.msg, "danger");
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  };

  const onDocumentSubmit = e => {
    e.preventDefault();
    setShowConfirm({ showPop: false, part: "" });
    var fd = new FormData();
    fd.append("caseId", props.match.params.id);
    fd.append("caseReference", caseFormData.CaseReference);
    fd.append("createBy", userId);
    fd.append("document", tempDocumentData);

    axios({
      method: "post",
      url: process.env.REACT_APP_API_URL + "/api/casedocumentsmap",
      data: fd
    })
      .then(res => {
        if (res.data.status === "0") {
          setAlert(res.data.msg, "success");
          setShowCaseDocument({ showPop: false, caseDocumentId: "" });
          reloadDocument();
        } else {
          setAlert(res.data.msg, "danger");
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const setDefault = () => {
    reloadImages();
    setSendEmailFormData({ ...sendEmailFormData, 
      subjectTxt: (caseFormData.Title || ''),
      bodyTxt: `<p><strong>` + (caseFormData.Title || '') + `</strong></p>
      <p>Owner : ` + (namesData[2].NamesName || '') + `</p>
      <p>Your Ref. : ` + (namesData[0].Reference || '') + `</p>
      <p>Our Ref. : ` + caseFormData.CaseReference + `/ ` + (namesData[4].Initial || '') + ` / ` + (namesData[5].Initial || '') + `</p>
      <p><br></p>` + imgFormData.imgBase64
    })
  }

  function toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
      var reader = new FileReader();
      reader.onloadend = function() {
        callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }

  function stripeCaseRef(selectedStr){
    //saveBillableCases
    const parts = selectedStr.split(',');
    const numbers = parts.map(part => part.split(':')[0]);
    return numbers.join(',');

  }
  const addLineBreaks = string =>
    string.split("\n").map((text, index) => (
      <React.Fragment key={`${text}-${index}`}>{text}<br/></React.Fragment>
    ));

  const button = () => {
    return (
      <div className="card-body text-right">
        <div>
        {
          <button
            className="btn ml-2" 
            style={{
              color: "#fff",
              backgroundColor: "lightseagreen",
              borderColor: "lightseagreen"
            }}
            type="button"
            onClick={() => {
              setShowEmail(true);
              setDefault();
            }}
            >
            <i className="fa fa-envelope"></i> E-mail
          </button>
        }
          <button
            className="btn ml-2"
            style={{
              color: "#fff",
              backgroundColor: "#c49f76",
              borderColor: "#c49f76"
            }}
            type="button"
            onClick={() => setShowKeepOnTop(true)}
          >
            <i className="fa fa-bullhorn"></i> Keep on Top
          </button>
          <Link to={"/cases/edit/" + props.match.params.id} hidden={!pagePermission.IsUpdate}>
            <button className="btn btn-primary ml-2" type="button">
              <i className="fa fa-pencil"></i> Edit
            </button>
          </Link>
          <button 
            className="btn btn-danger ml-2" 
            type="button" 
            hidden={!pagePermission.IsDelete}
            onClick={() => 
              setShowDelete({showPop: true, part: "case", Id: props.match.params.id })
            }>
            <i className="fa fa-remove"></i> Delete
          </button>
          <button
            className="btn btn-success ml-2"
            type="button"
            onClick={() => window.location.reload()}
          >
            <i className="fa fa-refresh"></i> Refresh
          </button>
          <Link to="/cases">
            <button className="btn btn-secondary ml-2" type="button">
              <i className="fa fa-reply"></i> Back
            </button>
          </Link>
        </div>
      </div>
    );
  };

  return (
    <Layout activeLinkTo="/cases" menuId="3">
      <div className="container-fluid" style={{ minHeight: 500 }}>
        <Alerts />
        {button()}
        <div className="card-body">
          <div className="card">
            <div className="card-body">
              <div className="form-group row">
                <div className="col-md-2">
                  <label className="control-label sbold l-view">IRN No:</label>
                </div>
                <div className="col-md-4">
                  <input
                    readOnly
                    type="text"
                    className="form-control signature form-control-sm"
                    value={caseFormData.CaseReference}
                  />
                </div>
                <div className="col-md-2">
                  <label className="control-label sbold l-view">
                    File Ref:
                  </label>
                </div>
                <div className="col-md-4">
                  <input
                    readOnly
                    type="text"
                    className="form-control signature form-control-sm"
                    value={caseFormData.CaseReference}
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-md-2">
                  <label className="control-label sbold l-view">Title :</label>
                </div>
                <div className="col-md-4">
                  <textarea
                    readOnly
                    className="form-control signature form-control-sm"
                    value={caseFormData.Title}
                  />
                </div>
                <div className="col-md-2">
                  <label className="control-label sbold l-view">Family :</label>
                </div>
                <div className="col-md-4">
                  <input
                    readOnly
                    type="text"
                    className="form-control signature form-control-sm"
                    value={caseFormData.Family}
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-md-2">
                  <label className="control-label sbold l-view">
                    Case Type :
                  </label>
                </div>
                <div className="col-md-4">
                  <input
                    readOnly
                    type="text"
                    className="form-control signature form-control-sm"
                    value={caseFormData.CaseTypeName}
                  />
                </div>
                <div className="col-md-2">
                  <label className="control-label sbold l-view">
                    Case Office :
                  </label>
                </div>
                <div className="col-md-4">
                  <input
                    readOnly
                    type="text"
                    className="form-control signature form-control-sm"
                    value={caseFormData.CaseOfficeName}
                  />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-2">
                  <label className="control-label sbold l-view">
                    Country :
                  </label>
                </div>
                <div className="col-md-4">
                  <input
                    readOnly
                    type="text"
                    className="form-control signature form-control-sm"
                    value={caseFormData.CountryName}
                  />
                </div>
                <div className="col-md-2">
                  <label className="control-label sbold l-view">
                    Type of Mark :
                  </label>
                </div>
                <div className="col-md-4">
                  <input
                    readOnly
                    type="text"
                    className="form-control signature form-control-sm"
                    value={caseFormData.TypeOfMarkName}
                  />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-2">
                  <label className="control-label sbold l-view">Basis :</label>
                </div>
                <div className="col-md-4">
                  <input
                    readOnly
                    type="text"
                    className="form-control signature form-control-sm"
                    value={caseFormData.BasisName}
                  />
                </div>
                <div className="col-md-2">
                  <label className="control-label sbold l-view">
                    No In Series :
                  </label>
                </div>
                <div className="col-md-4">
                  <input
                    readOnly
                    type="text"
                    className="form-control signature form-control-sm"
                    value={caseFormData.NoInSeries}
                    onChange={onchange}
                  />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-2">
                  <label className="control-label sbold l-view">
                    Case Status :
                  </label>
                </div>
                <div className="col-md-4">
                  <input
                    readOnly
                    type="text"
                    className="form-control signature form-control-sm"
                    value={caseFormData.CaseStatusName}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="card">
            <div className="card-body">
              <Tabs selectedIndex={selectTab} onSelect={c => setSelectTab(c)}>
                <TabList>
                  <Tab onClick={() => reloadNames()}>Names</Tab>
                  <Tab onClick={() => { reloadImages(); }}>Image</Tab>
                  <Tab onClick={() => {
                    reloadClasses();
                  }}>Classes</Tab>
                  <Tab onClick={() => {
                    reloadOfficialNumber();
                    //Load Type Offial Number DDL
                    axios
                    .get(process.env.REACT_APP_API_URL + "/api/officenumbertype/ddl")
                    .then(res => {
                      setOfficenumbertypeDdl(res.data);
                    });
                  }} >Official Numbers</Tab>
                  <Tab onClick={() => {
                    reloadRelatedCase(caseFormData.Family, caseFormData.CaseReference);
                  }}>Related Cases</Tab>
                  <Tab onClick={() => {
                    reloadBillableCase(caseFormData.Family, caseFormData.CaseReference);
                  }}>Billable Cases</Tab>
                  <Tab onClick={() => {
                    reloadEvent();
                    //Load Event DDL
                    axios.get(process.env.REACT_APP_API_URL + "/api/events/ddl/" , {
                      params: { caseTypeId:caseFormData.CaseTypeId }
                    } ).then(res => {
                      setEventsDdl(res.data);
                    });
                  }}>Events</Tab>
                  <Tab onClick={() => { reloadDocument(); }}>Document</Tab>
                </TabList>
                <TabPanel> {/* Names */}
                  <div className="table-responsive">
                    <button
                      hidden={!pagePermission.IsUpdate}
                      className="btn btn-primary"
                      onClick={() => {
                        setShowCaseName(true);
                      }}
                    >
                      <i className="fa fa-pencil"></i> Edit
                    </button>
                    <DataTable
                      noHeader={true}
                      pagination={true}
                      columns={namesColumn}
                      data={namesData}
                    />
                  </div>
                </TabPanel>
                <TabPanel> {/* Image */}
                  <form encType="multipart/form-data" onSubmit={onImgSubmit}>
                    <input type="file" name="avatar" onChange={getFileSelect} />
                    <button className="btn btn-primary">
                      <i className="fa fa-upload"></i> Upload
                    </button>
                    <p></p>
                    <div className="js-tilt ml-5 mt-5 mb-5 mr-5" data-tilt>
                      <div className="table-responsive">
                        
                          {imgFormData && imgFormData.filePath !== "" && (
                            <img
                              src={
                                "/images/uploads/" + imgFormData.filePath
                              }
                              alt="IMG"
                            ></img>
                          )}
                          {( !imgFormData || imgFormData.filePath === "") && (
                            <img src="/images/logo/no-img.png" alt="IMG"></img>
                          )}
                        
                      </div>
                    </div>
                  </form>
                </TabPanel>
                <TabPanel> {/* Classes */}
                  <div className="card">
                    <div className="card-body">
                      <div className="form-group row">
                        <div className="col-md-2">
                          <label className="control-label sbold l-view">
                            Total Local:
                          </label>
                        </div>
                        <div className="col-md-4">
                          <input
                            readOnly
                            type="text"
                            className="form-control signature form-control-sm"
                            value={classes_total}
                          />
                        </div>
                        <div className="col-md-2">
                          <label className="control-label sbold l-view">
                            Local Classes:
                          </label>
                        </div>
                        <div className="col-md-4">
                          <input
                            readOnly
                            type="text"
                            className="form-control signature form-control-sm"
                            value={classesList.map(x => ' ' + x )}
                          />
                        </div>
                      </div>
                      <div className="table-responsive">
                        <button
                          hidden={!pagePermission.IsCreate}
                          type="button"
                          className="btn btn-success"
                          onClick={() => {
                            //Load Classes DDL
                            axios.get(process.env.REACT_APP_API_URL + "/api/classes").then(res => {
                              setClassesMasData(res.data.filter(x => !classesList.includes(x.ClassesCode)));
                            });
                            setShowClasses(true);
                          }}
                        >
                          <i className="fa fa-plus"></i> Add
                        </button>
                        <DataTable
                          noHeader={true}
                          pagination={true}
                          columns={[
                            {
                              cell: row => (
                                <div>
                                  <button
                                    hidden={!pagePermission.IsUpdate}
                                    className="btn btn-sm btn-primary"
                                    onClick={() => {
                                      setShowCaseClass({
                                        showPop: true, caseClassId: row.CaseClassId
                                      });
                                    }}
                                  >
                                    <i className="fa fa-pencil"></i> Edit
                                  </button>
                                  <button
                                    hidden={!pagePermission.IsDelete}
                                    className="btn btn-sm btn-danger ml-2"
                                    onClick={() => {
                                      setShowDelete({showPop: true, part: "caseClass", Id: row.CaseClassId })
                                    }}
                                  >
                                    <i className="fa fa-remove"></i> Delete
                                  </button>
                                </div>
                              ),
                              ignoreRowClick: false,
                              allowOverflow: true,
                              width: pagePermission.IsUpdate|| pagePermission.IsDelete ? "163px" : "0px",
                              button: true
                            },
                            ...classesColumn
                          ]}
                          data={classesData}
                        />
                      </div>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel> {/* Official Numbers */}
                  <button
                    hidden={!pagePermission.IsCreate}
                    className="btn btn-success"
                    type="button"
                    onClick={() => {
                      setShowCaseOfficialNumber({
                        showPop: true,
                        show: "Add",
                        caseOfficialNumberId: ""
                      });
                    }}
                  >
                    <i className="fa fa-plus"></i> Add
                  </button>
                  <div className="table-responsive">
                    <DataTable
                      noHeader={true}
                      pagination={true}
                      columns={officialNumbersColumn}
                      data={officialNumbersData}
                    />
                  </div>
                </TabPanel>
                <TabPanel> {/* Related Cases */}
                  <div className="card">
                    <div className="card-body">
                      <div className="table-responsive">
                        <button
                          hidden={!pagePermission.IsUpdate}
                          className="btn btn-primary"
                          type="button"
                          onClick={() => {
                            setShowRelatedCase(true);
                            // Load Case Releted
                            axios
                              .get(process.env.REACT_APP_API_URL + "/api/relatedcase", {
                                params: { caseId: props.match.params.id, family: caseFormData.Family, caseReference: caseFormData.CaseReference }
                              })
                              .then(res => {
                                setRelatedCaseModalData(res.data);
                              });
                            //get selected row
                            axios
                              .get(process.env.REACT_APP_API_URL + "/api/caserelatedcasemap/relate", {
                                params: { caseId: props.match.params.id }
                              }).then(res => {
                                setSelectedRelateRows(
                                  res.data.map(x => parseInt(x.CaseRefId, 10) )
                                );
                              });
                          }}
                        >
                          <i className="fa fa-pencil"></i> Edit
                        </button>
                        <DataTable
                          noHeader={true}
                          pagination={true}
                          columns={relatedCaseColumn}
                          data={relatedCaseData}
                        />
                      </div>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel> {/* Billable Cases */}
                  <div className="card">
                    <div className="card-body">
                      <div className="table-responsive">
                        <button
                          hidden={!pagePermission.IsUpdate}
                          className="btn btn-primary"
                          type="button"
                          onClick={() => {
                            setShowBillableCase(true);
                            // Load Case Releted
                            axios
                              .get(process.env.REACT_APP_API_URL + "/api/billablecase", {
                                params: { 
                                  caseId: props.match.params.id, 
                                  family: caseFormData.Family, 
                                  caseReference: caseFormData.CaseReference }
                              })
                              .then(res => {
                                setBillableCaseModalData(res.data);
                              });
                            //get selected row
                            axios
                              .get(process.env.REACT_APP_API_URL + "/api/casebillablecasemap/relate", {
                                params: { caseId: props.match.params.id }
                              }).then(res => {
                                console.log(res);
                                setSelectedBillableRows(
                                  res.data.filter(x => x.CaseBillId !== 0 && x.CaseReference != null)
                                  .map(x => x.CaseBillId + ":"+x.CaseReference )
                                );
                                setSelectedBillList(
                                  res.data.filter(x => x.CaseBillId !== 0 && x.CaseReference != null)
                                  .map(x => x.CaseBillId + ":"+x.CaseReference )
                                );
                              });
                          }}
                        >
                          <i className="fa fa-pencil"></i> Edit
                        </button>
                        <DataTable
                          noHeader={true}
                          pagination={true}
                          columns={billableCaseColumn}
                          data={billableCaseData}
                        />
                      </div>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel> {/* Events */}
                  <div className="table-responsive" style={{overflowX:"hidden"}}>
                  <button
                    hidden={!pagePermission.IsCreate}
                    type="button"
                    className="btn btn-success"
                    onClick={() => {
                      setshowCaseEvent({
                        showPop: true,
                        show: "Add",
                        caseEventId: ""
                      });
                    }}
                  >
                    <i className="fa fa-plus"></i> Add
                  </button>
                    <div className="row">
                      <div className="col-md-6">
            
                        <div id="CaseOpeningTab">
                          <DataTable style={{overflowY:"hidden", minHeight:"0", marginTop:"0"}}
                            noHeader={true}
                            pagination={false}
                            columns={eventsOpenning}
                            data={eventsOpenningData}
                          />
                        </div>
                        <div>
                          <DataTable style={{overflowY:"hidden", minHeight:"217px"}}
                            noHeader={true}
                            pagination={true}
                            columns={eventsSuccessColumn}
                            data={eventsSuccessData}
                          />
                        </div>

                      </div>
                      <div className="col-md-6">
                        <DataTable style={{overflowY:"hidden", minHeight:"217px"}}
                          noHeader={true}
                          pagination={true}
                          columns={eventsNotyetColumn}
                          data={eventsNotyetData}
                        />
                      </div>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel> {/* Document */}
                  <div className="card">
                    <div className="card-body">
                      <div className="table-responsive">
                        <button
                          hidden={!pagePermission.IsCreate}
                          type="button"
                          className="btn btn-success"
                          onClick={() => {
                            setShowCaseDocument({
                              showPop: true,
                              show: "Add",
                              caseDocumentId: ""
                            });
                          }}
                        >
                          <i className="fa fa-plus"></i> Add
                        </button>
                        <DataTable
                          noHeader={true}
                          pagination={true}
                          columns={documentColumn}
                          data={documentData}
                        />
                      </div>
                    </div>
                  </div>
                </TabPanel>
            
              </Tabs>
            </div>
          </div>
        </div>
        {button()}
      </div>
      {/* Madal Keep on top */}
      <Modal show={showKeepOnTop} onHide={() => setShowKeepOnTop(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fa fa-bullhorn"></i>
          </Modal.Title>
          <div style={{ margin: "auto 23px" }}>
            <p style={{overflowWrap:"break-word", width:"370px"}}>{addLineBreaks(caseFormData.KeepOnTopNote)}</p>
          </div>
        </Modal.Header>
      </Modal>
      {/* Madal Keep on top */}

      {/* Madal confirm add/edit */}
      <Modal
        show={showConfirm.showPop}
        onHide={() => {
          setShowConfirm({ showPop: false, part: "" });
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        {/*<Modal.Body><Alerts /></Modal.Body>*/}
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            onClick={() => {
              setShowConfirm({ showPop: false, part: "" });
            }}
          >
            <i className="fa fa-reply"></i> Cancel
          </button>
          <button
            className="btn btn-success ml-2"
            type="button"
            onClick={() => {
              switch (showConfirm.part) {
                case "Names":
                  saveEditCaseNames();
                  break;
                case "AddClasses":
                  saveCaseClass("Add");
                  break
                case "EditClasses":
                  saveCaseClass("Edit");
                  break;
                case "Event":
                  saveCaseEvent();
                  break;
                case "OfficialNumber":
                  saveOfficialNumber();
                  break;
                case "RelatedCases":
                  saveRelatedCases();
                  break;
                case "BillableCases":
                  saveBillableCases();
                  break;                  
                case "SendEmail":
                  saveSendEmail();
                  break
                default:
                  break;
              }
            }}
          >
            <i className="fa fa-floppy-o"></i> Save
          </button>
        </Modal.Footer>
      </Modal>
      {/* Madal confirm add/edit */}

      {/* Modal confirm delete document*/}
      <Modal
        show={showDeleteDocument.showPop}
        onHide={() => {
          setShowDeleteDocument({ caseDocumentId: "", showPop: false });
        }}
        centered
      >
        <Modal.Header closeButton>
          <div
            style={{
              width: 39,
              height: 39,
              borderWidth: 4,
              borderStyle: "solid",
              borderColor: "red",
              borderRadius: "50%",
              position: "relative"
            }}
          >
            <span
              style={{
                width: 24,
                height: 5,
                position: "absolute",
                backgroundColor: "red",
                top: 13,
                left: 3,
                transform: "rotate(45deg)"
              }}
            ></span>
            <span
              style={{
                width: 24,
                height: 5,
                position: "absolute",
                backgroundColor: "red",
                top: 13,
                left: 3,
                transform: "rotate(-45deg)"
              }}
            ></span>
          </div>
          <Modal.Title style={{ paddingLeft: 13 }}>Delete Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Please make sure Once deleted, items cannot be returned.</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary ml-2"
            onClick={() => {
              setShowDeleteDocument({ caseDocumentId: "", showPop: false });
            }}
          >
            <i className="fa fa-reply"></i> Cancel
          </button>
          <button
            className="btn btn-danger ml-2"
            type="button"
            onClick={() => {
              axios
                .put(
                  process.env.REACT_APP_API_URL +
                    "/api/casedocumentsmap/delete/" +
                    showDeleteDocument.caseDocumentId,
                  {
                    createBy: userId
                  }
                )
                .then(res => {
                  setShowDeleteDocument({ caseDocumentId: "", showPop: false });
                  setAlert(res.data.msg, "danger");
                  reloadDocument();
                });
            }}
          >
            <i className="fa fa-trash-o"></i> Continue
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal confirm delete document*/}

      {/* Modal Delete showDeleteRelatedCase */}
      <Modal
        show={showDeleteRelatedCase.showPop}
        onHide={() => {
          setShowDelete({ showPop: false, part: "", Id: "" });
        }}
        centered
      >
        <Modal.Header closeButton>
          <div
            style={{
              width: 39,
              height: 39,
              borderWidth: 4,
              borderStyle: "solid",
              borderColor: "red",
              borderRadius: "50%",
              position: "relative"
            }}
          >
            <span
              style={{
                width: 24,
                height: 5,
                position: "absolute",
                backgroundColor: "red",
                top: 13,
                left: 3,
                transform: "rotate(45deg)"
              }}
            ></span>
            <span
              style={{
                width: 24,
                height: 5,
                position: "absolute",
                backgroundColor: "red",
                top: 13,
                left: 3,
                transform: "rotate(-45deg)"
              }}
            ></span>
          </div>
          <Modal.Title style={{ paddingLeft: 13 }}>
            Delete {showDeleteRelatedCase.part}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alerts />
          <p>Please make sure Once deleted, items cannot be returned.</p>
         
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary ml-2"
            onClick={() => {
              setShowDeleteRelatedCase({ showPop: false, part: "", Id: "" });
            }}
          >


            <i className="fa fa-reply"></i> Cancel
          </button>
          <button
            className="btn btn-danger ml-2"
            type="button"
            onClick={() => {
              console.log(`showDeleteRelatedCase.Id : ${showDeleteRelatedCase.RefId}`);
              console.log(`showDeleteRelatedCase.RefId : ${showDeleteRelatedCase.Id}`);

              
              axios
                .put(
                  process.env.REACT_APP_API_URL +
                    "/api/caserelatedcasemap/delete/" +
                    showDeleteRelatedCase.Id,

                  {
                    createBy: userId,
                    caseId: showDeleteRelatedCase.Id,
                    caseRefId: showDeleteRelatedCase.RefId,
                  }
                )
                .then(res => {
                  setShowDeleteRelatedCase({ caseDocumentId: "", showPop: false });
                  setAlert(res.data.msg, "danger");
                  reloadRelatedCase(caseFormData.Family, caseFormData.CaseReference);
                });
                
            }}
          >
            <i className="fa fa-trash-o"></i> Continue
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Delete showDeleteRelatedCase */}
      
      {/* Modal Delete */}
      <Modal
        show={showDelete.showPop}
        onHide={() => {
          setShowDelete({ showPop: false, part: "", Id: "" });
        }}
        centered
      >
        <Modal.Header closeButton>
          <div
            style={{
              width: 39,
              height: 39,
              borderWidth: 4,
              borderStyle: "solid",
              borderColor: "red",
              borderRadius: "50%",
              position: "relative"
            }}
          >
            <span
              style={{
                width: 24,
                height: 5,
                position: "absolute",
                backgroundColor: "red",
                top: 13,
                left: 3,
                transform: "rotate(45deg)"
              }}
            ></span>
            <span
              style={{
                width: 24,
                height: 5,
                position: "absolute",
                backgroundColor: "red",
                top: 13,
                left: 3,
                transform: "rotate(-45deg)"
              }}
            ></span>
          </div>
          <Modal.Title style={{ paddingLeft: 13 }}>
            Delete {showDelete.part}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alerts />
          <p>Please make sure Once deleted, items cannot be returned.</p>
          { showDelete.part === "case" && (
            <div className="form-group col labelPadRight">
              <br/>
              <div className="form-group row col">
                <label className="col-md-3 col-form-label form-control-sm sbold">
                  Annotation <span style={{ color: "red" }}>*</span> :
                </label>
                <div className="input-group col-md-9">
                  <input 
                    className="form-control form-control-sm"
                    type="text"
                    name="annotationDel"
                    value={annotationDel}
                    onChange={ e => setAnnotationDel(e.target.value)}
                  />
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary ml-2"
            onClick={() => {
              setShowDelete({ showPop: false, part: "", Id: "" });
            }}
          >
            <i className="fa fa-reply"></i> Cancel
          </button>
          <button
            className="btn btn-danger ml-2"
            type="button"
            onClick={() => {
              switch (showDelete.part) {
                case "OfficialNumber":
                  axios
                    .put(
                      process.env.REACT_APP_API_URL +
                        "/api/caseofficialnumbermap/delete/" +
                        showDelete.Id,
                      { createBy: userId }
                    )
                    .then(res => {
                      setShowDelete({ showPop: false, part: "", Id: "" });
                      setAlert(res.data.msg, "danger");
                      reloadOfficialNumber();
                    });
                  break;
                case "case":
                  if(!annotationDel){
                    setAlert('Please fill annotation', "danger");
                  }
                  else {axios
                    .put(
                      process.env.REACT_APP_API_URL +
                        "/api/case/manage/deletecase/" +
                        showDelete.Id,
                      { createBy: userId, annotationDel: annotationDel }
                    )
                    .then(res => {
                      setShowDelete({ showPop: false, part: "", Id: "" });
                      setAlert(res.data.msg, "danger");
                      props.history.push("/cases");
                    });}
                  break;
                case "event":
                  axios
                  .put(
                    process.env.REACT_APP_API_URL +
                      "/api/caseeventmap/delete/" +
                      showDelete.Id,
                    { createBy: userId }
                  )
                  .then(res => {
                    setShowDelete({ showPop: false, part: "", Id: "" });
                    setAlert(res.data.msg, "danger");
                    reloadEvent();
                  });
                  break;
                case "caseClass":
                  axios
                  .put(
                    process.env.REACT_APP_API_URL +
                      "/api/caseclassesmap/delete/" +
                      showDelete.Id,
                    { createBy: userId }
                  )
                  .then(res => {
                    setShowDelete({ showPop: false, part: "", Id: "" });
                    setAlert(res.data.msg, "danger");
                    reloadClasses();
                  });
                  break
                default:
                  break;
              }
            }}
          >
            <i className="fa fa-trash-o"></i> Continue
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Delete */}

      {/* Modal Edit Case Names */}
      <Modal
        show={showCaseName}
        onHide={() => {
          setShowCaseName(false);
        }}
        centered
        //dialogClassName="modal-w"
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Case Names</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group col labelPadRight">
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Type:
              </label>
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Name:
              </label>
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Attention:
              </label>
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Reference:
              </label>
            </div>
            <div className="form-group row col">{/* Instructor */}
              <div className="input-group col-md-3">
                <input
                  readOnly
                  type="text"
                  className="form-control  form-control-sm"
                  name="type"
                  value="Instructor"
                />
              </div>
              <div className="col-md-3">
                <Select
                  name="namesId"
                  value={{
                    value: namesFormData.Instructor.namesId || 0,
                    label: namesFormData.Instructor.namesName || "Please Select"
                  }}
                  options={namesDdl}
                  onChange={e => {
                    if((parseInt(namesFormData.Debtor.namesId) === 0 || namesFormData.Debtor.namesId === null) && 
                      (parseInt(namesFormData.Owner.namesId) === 0 || namesFormData.Owner.namesId === null )){
                      setNamesFormData({ ...namesFormData,
                        Instructor:{ ...namesFormData.Instructor, namesId: e.value, namesName: e.label },
                        Debtor:{ ...namesFormData.Debtor, namesId: e.value, namesName: e.label },
                        Owner:{ ...namesFormData.Owner, namesId: e.value, namesName: e.label }
                      });
                    } else {
                      setNamesFormData({
                        ...namesFormData,
                        Instructor:{
                          ...namesFormData.Instructor,
                          namesId: e.value,
                          namesName: e.label
                        }
                      });
                    }
                  }}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="attention"
                  value={namesFormData.Instructor.attention || ""}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Instructor:{
                        ...namesFormData.Instructor,
                        attention:  e.target.value
                      }
                    })
                  }}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="reference"
                  value={namesFormData.Instructor.reference || ""}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Instructor:{
                        ...namesFormData.Instructor,
                        reference:  e.target.value
                      }
                    })
                  }}
                />
              </div>
            </div>
            <div className="form-group row col">{/* Debtor */}
              <div className="input-group col-md-3">
                <input
                  readOnly
                  type="text"
                  className="form-control  form-control-sm"
                  name="type"
                  value="Debtor"
                />
              </div>
              <div className="col-md-3">
                <Select
                  name="namesId"
                  value={{
                    value: namesFormData.Debtor.namesId || 0,
                    label: namesFormData.Debtor.namesName || "Please Select"
                  }}
                  options={namesDdl}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Debtor:{
                        ...namesFormData.Debtor,
                        namesId: e.value,
                        namesName: e.label
                      }
                    });
                  }}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="attention"
                  value={namesFormData.Debtor.attention || ""}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Debtor:{
                        ...namesFormData.Debtor,
                        attention:  e.target.value
                      }
                    })
                  }}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="reference"
                  value={namesFormData.Debtor.reference || ""}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Debtor:{
                        ...namesFormData.Debtor,
                        reference:  e.target.value
                      }
                    })
                  }}
                />
              </div>
            </div>
            <div className="form-group row col">{/* Owner */}
              <div className="input-group col-md-3">
                <input
                  readOnly
                  type="text"
                  className="form-control  form-control-sm"
                  name="type"
                  value="Owner"
                />
              </div>
              <div className="col-md-3">
                <Select
                  name="namesId"
                  value={{
                    value: namesFormData.Owner.namesId || 0,
                    label: namesFormData.Owner.namesName || "Please Select"
                  }}
                  options={namesDdl}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Owner:{
                        ...namesFormData.Owner,
                        namesId: e.value,
                        namesName: e.label
                      }
                    });
                  }}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="attention"
                  value={namesFormData.Owner.attention || ""}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Owner:{
                        ...namesFormData.Owner,
                        attention:  e.target.value
                      }
                    })
                  }}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="reference"
                  value={namesFormData.Owner.reference || ""}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Owner:{
                        ...namesFormData.Owner,
                        reference:  e.target.value
                      }
                    })
                  }}
                />
              </div>
            </div>
            <div className="form-group row col">{/* Agent */}
              <div className="input-group col-md-3">
                <input
                  readOnly
                  type="text"
                  className="form-control  form-control-sm"
                  name="type"
                  value="Agent"
                />
              </div>
              <div className="col-md-3">
                <Select
                  name="namesId"
                  value={{
                    value: namesFormData.Agent.namesId || 0,
                    label: namesFormData.Agent.namesName || "Please Select"
                  }}
                  options={namesDdl}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Agent:{
                        ...namesFormData.Agent,
                        namesId: e.value,
                        namesName: e.label
                      }
                    });
                  }}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="attention"
                  value={namesFormData.Agent.attention || ""}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Agent:{
                        ...namesFormData.Agent,
                        attention:  e.target.value
                      }
                    })
                  }}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="reference"
                  value={namesFormData.Agent.reference || ""}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Agent:{
                        ...namesFormData.Agent,
                        reference:  e.target.value
                      }
                    })
                  }}
                />
              </div>
            </div>
            <div className="form-group row col">{/* Refferal */}
              <div className="input-group col-md-3">
                <input
                  readOnly
                  type="text"
                  className="form-control  form-control-sm"
                  name="type"
                  value="Refferal"
                />
              </div>
              <div className="col-md-3">
                <Select
                  name="namesId"
                  value={{
                    value: namesFormData.Refferal.namesId || 0,
                    label: namesFormData.Refferal.namesName || "Please Select"
                  }}
                  options={namesDdl}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Refferal:{
                        ...namesFormData.Refferal,
                        namesId: e.value,
                        namesName: e.label
                      }
                    });
                  }}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="attention"
                  value={namesFormData.Refferal.attention || ""}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Refferal:{
                        ...namesFormData.Refferal,
                        attention:  e.target.value
                      }
                    })
                  }}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="reference"
                  value={namesFormData.Refferal.reference || ""}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Refferal:{
                        ...namesFormData.Refferal,
                        reference:  e.target.value
                      }
                    })
                  }}
                />
              </div>
            </div>
            <div className="form-group row col">{/* Partner */}
              <div className="input-group col-md-3">
                <input
                  readOnly
                  type="text"
                  className="form-control  form-control-sm"
                  name="type"
                  value="Partner"
                />
              </div>
              <div className="col-md-3">
                <Select
                  name="namesId"
                  value={{
                    value: namesFormData.Partner.namesId || 0,
                    label: namesFormData.Partner.namesName || "Please Select"
                  }}
                  options={namesDdl}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Partner:{
                        ...namesFormData.Partner,
                        namesId: e.value,
                        namesName: e.label
                      }
                    });
                  }}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="attention"
                  value={namesFormData.Partner.attention || ""}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Partner:{
                        ...namesFormData.Partner,
                        attention:  e.target.value
                      }
                    })
                  }}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="reference"
                  value={namesFormData.Partner.reference || ""}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Partner:{
                        ...namesFormData.Partner,
                        reference:  e.target.value
                      }
                    })
                  }}
                />
              </div>
            </div>
            <div className="form-group row col">{/* Attorney */}
              <div className="input-group col-md-3">
                <input
                  readOnly
                  type="text"
                  className="form-control  form-control-sm"
                  name="type"
                  value="Attorney"
                />
              </div>
              <div className="col-md-3">
                <Select
                  name="namesId"
                  value={{
                    value: namesFormData.Attorney.namesId || 0,
                    label: namesFormData.Attorney.namesName || "Please Select"
                  }}
                  options={namesDdl}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Attorney:{
                        ...namesFormData.Attorney,
                        namesId: e.value,
                        namesName: e.label
                      }
                    });
                  }}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="attention"
                  value={namesFormData.Attorney.attention || ""}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Attorney:{
                        ...namesFormData.Attorney,
                        attention:  e.target.value
                      }
                    })
                  }}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="reference"
                  value={namesFormData.Attorney.reference || ""}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Attorney:{
                        ...namesFormData.Attorney,
                        reference:  e.target.value
                      }
                    })
                  }}
                />
              </div>
            </div>
            <div className="form-group row col">{/* Executive */}
              <div className="input-group col-md-3">
                <input
                  readOnly
                  type="text"
                  className="form-control  form-control-sm"
                  name="type"
                  value="Executive"
                />
              </div>
              <div className="col-md-3">
                <Select
                  name="namesId"
                  value={{
                    value: namesFormData.Executive.namesId || 0,
                    label: namesFormData.Executive.namesName || "Please Select"
                  }}
                  options={namesDdl}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Executive:{
                        ...namesFormData.Executive,
                        namesId: e.value,
                        namesName: e.label
                      }
                    });
                  }}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="attention"
                  value={namesFormData.Executive.attention || ""}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Executive:{
                        ...namesFormData.Executive,
                        attention:  e.target.value
                      }
                    })
                  }}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="reference"
                  value={namesFormData.Executive.reference || ""}
                  onChange={e => {
                    setNamesFormData({
                      ...namesFormData,
                      Executive:{
                        ...namesFormData.Executive,
                        reference:  e.target.value
                      }
                    })
                  }}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            onClick={() => {
              setShowCaseName(false);
            }}
          >
            <i className="fa fa-reply"> Cancel </i>
          </button>
          <button
            className="btn btn-success ml-2"
            onClick={() => {
              setShowConfirm({ showPop: true, part: "Names" });
            }}
          >
            <i className="fa fa-floppy-o"> Save</i>
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Edit Case Names */}

      {/* Modal Edit Case Classes */}
      <Modal
        show={showCaseClass.showPop}
        onHide={() => {
          setShowCaseClass({ showPop: false, caseClassId: "" });
        }}
        centered
        dialogClassName="modal-w"
      >
        <Modal.Header closeButton>
            <Modal.Title>Edit Case Classes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group col labelPadRight">
            <Alerts />
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Class:
              </label>
              <div className="input-group col-md-9">
                <input
                  readOnly
                  type="text"
                  className="form-control  form-control-sm"
                  name="classesCode"
                  value={classFormData.classesCode}
                  onChange={onChangeClasses}
                />
                <div className="input-group-append" hidden={true}>
                  <button
                    className="btn btn-sm btn-outline-primary form-control-sm"
                    type="button"
                    onClick={() => {
                      setShowClasses(true);
                    }}
                  >
                    <i className="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                TextEN:
              </label>
              <div className="col-md-9">
                <textarea
                  type="text"
                  className="form-control  form-control-sm"
                  name="classesTextEN"
                  value={classFormData.classesTextEN}
                  onChange={onChangeClasses}
                ></textarea>
              </div>
            </div>
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                TextTH:
              </label>
              <div className="col-md-9">
                <textarea
                  type="text"
                  className="form-control  form-control-sm"
                  name="classesTextTH"
                  value={classFormData.classesTextTH}
                  onChange={onChangeClasses}
                ></textarea>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            onClick={() => {
              setShowCaseClass({ showPop: false, caseClassId: "" });
            }}
          >
            <i className="fa fa-reply"> Cancel </i>
          </button>
          <button
            className="btn btn-success ml-2"
            onClick={() => {
              setShowConfirm({ showPop: true, part: "EditClasses" });
            }}
          >
            <i className="fa fa-floppy-o"> Save</i>
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Edit Case Classes */}

      {/* Modal Classes */}
      <Modal
        show={showClasses}
        onHide={() => {
          setShowClasses(false);
        }}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Classes</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{paddingBottom:"26px"}}>
          <div className="card-body text-right" style={{padding:"0px"}}>
            <button
              className="btn btn-danger ml-2"
              type="button"
              onClick={() => {
                setShowClasses(false);
              }}
            >
              <i className="fa fa-reply"></i> Close
            </button>
            <button
              className="btn btn-success ml-2"
              onClick={() => {
                setShowConfirm({ showPop: true, part: "AddClasses" });
              }}
            >
              <i className="fa fa-floppy-o"> Save</i>
            </button>
          </div>
          <div className="table-responsive">
            <a href="#down" id="top" style={{position:"absolute", right:"0px", padding:"29px 31px 0 0", zIndex:"1"}}>
              <i className="fa fa-arrow-down" style={{color:"#c8c8c8"}}/>
            </a>
            <DataTable
              noHeader={true}
              pagination={true}
              columns={classesColumn}
              data={classForMap}
              paginationPerPage={50}
              paginationRowsPerPageOptions={[5, 10, 20, 50, 100]}
              selectableRows
              onSelectedRowsChange={selectClassChange}
              selectableRowSelected={row => selectedClassRows.includes(parseInt(row.ClassesId, 10) )}
            />
            <a href="#top" id="down" style={{position:"absolute", right:"0px", padding:"0 31px"}}>
              <i className="fa fa-arrow-up" style={{color:"#c8c8c8"}}/>
            </a>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            type="button"
            onClick={() => {
              setShowClasses(false);
            }}
          >
            <i className="fa fa-reply"></i> Close
          </button>
          <button
            className="btn btn-success ml-2"
            onClick={() => {
              setShowConfirm({ showPop: true, part: "AddClasses" });
            }}
          >
            <i className="fa fa-floppy-o"> Save</i>
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Classes */}

      {/* Modal Add/Edit Case Event */}
      <Modal
        show={showCaseEvent.showPop}
        onHide={() => {
          setshowCaseEvent({
            showPop: false,
            show: "",
            caseEventId: ""
          });
        }}
        centered
        dialogClassName="modal-w"
      >
        <Modal.Header closeButton>
          {showCaseEvent.show === "Add" && (
            <Modal.Title>Add Case Event</Modal.Title>
          )}
          {showCaseEvent.show === "Edit" && (
            <Modal.Title>Edit Case Event</Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          <div className="form-group col labelPadRight">
            <Alerts />
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Event :
              </label>
              <div className="col-md-9">
                <Select
                  value={{
                    value: eventFormData.eventId || 0,
                    label: eventFormData.eventName || "Please Select"
                  }}
                  options={eventsDdl}
                  onChange={e => {
                    setEventFormData({
                      ...eventFormData,
                      hasDeadLine: e.HasDeadLine,
                      eventId: e.value,
                      eventName: e.label
                    });
                  }}
                  isDisabled = {showCaseEvent.show === "Edit"}
                />
              </div>
            </div>

            { (eventFormData.eventName == 'Other') &&
              <div className="form-group row col">
                <label className="col-md-3 col-form-label form-control-sm sbold">
                  Event Remark :
                </label>
                <div className="col-md-9">
                  <input
                      type="text"
                      className="form-control  form-control-sm"
                      name="eventRemark"
                      value={eventFormData.eventRemark}
                      onChange={e => {
                        setEventFormData({
                          ...eventFormData,
                          eventRemark: e.target.value  
                        });
                      }}
                    />
                </div>
              </div>
            }


            { (!eventFormData.hasDeadLine && eventFormData.eventId !== 0) &&
              <div className="form-group row col">
                <label className="col-md-3 col-form-label form-control-sm sbold">
                  Occurred Date :
                </label>
                <div className="col-md-9">
                  <div className="input-group">
                  <DatePicker
                    dateFormat="yyyy/MM/dd"
                    placeholderText="occurred date"
                    selected={eventFormData.occurredDate}
                    onChange={date => {
                      setEventFormData({
                        ...eventFormData,
                        occurredDate: date
                      });
                    }}
                    customInput={
                      <input
                        className="form-control  form-control-sm"
                        style={{
                          borderTopRightRadius: 0,
                          borderBottomRightRadius: 0
                        }}
                      />
                    }
                  />
                  </div>
                </div>
              </div>
            }
            { eventFormData.hasDeadLine > 0 && <div>
              <div className="form-group row col">
                <label className="col-md-3 col-form-label form-control-sm sbold" style={{padding:"0"}}>
                  Start Date <span style={{ color: "red" }}>*</span> :
                </label>
                <div className="col-md-9">
                  <div className="input-group">
                    <DatePicker
                      dateFormat="yyyy/MM/dd"
                      placeholderText="start date"
                      selected={eventFormData.startDate}
                      maxDate={
                        eventFormData.completeDate === null
                          ? eventFormData.dueDate
                          : eventFormData.dueDate >
                            eventFormData.completeDate
                          ? eventFormData.completeDate
                          : eventFormData.dueDate
                      }
                      onChange={date => {
                        setEventFormData({
                          ...eventFormData,
                          startDate: date
                        });
                      }}
                      customInput={
                        <input
                          className="form-control  form-control-sm"
                          style={{
                            borderTopRightRadius: 0,
                            borderBottomRightRadius: 0
                          }}
                        />
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row col">
                <label className="col-md-3 col-form-label form-control-sm sbold" style={{padding:"0"}}>
                  Due Date <span style={{ color: "red" }}>*</span> :
                </label>
                <div className="col-md-9">
                  <div className="input-group">
                    <DatePicker
                      dateFormat="yyyy/MM/dd"
                      placeholderText="due date"
                      selected={eventFormData.dueDate}
                      minDate={eventFormData.startDate}
                      onChange={date => {
                        setEventFormData({
                          ...eventFormData,
                          dueDate: date
                        });
                      }}
                      customInput={
                        <input
                          className="form-control  form-control-sm"
                          style={{
                            borderTopRightRadius: 0,
                            borderBottomRightRadius: 0
                          }}
                        />
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold" style={{padding:"0"}}>
                Complete Date :
              </label>
              <div className="col-md-9">
                <div className="input-group">
                  <DatePicker
                    dateFormat="yyyy/MM/dd"
                    placeholderText="complete date"
                    selected={eventFormData.completeDate}
                    minDate={eventFormData.startDate}
                    highlightDates={[
                      {
                        "highlighted-days":
                          eventFormData.dueDate === null
                            ? []
                            : [eventFormData.dueDate]
                      }
                    ]}
                    onChange={date => {
                      setEventFormData({
                        ...eventFormData,
                        completeDate: date
                      });
                    }}
                    customInput={
                      <input
                        className="form-control  form-control-sm"
                        style={{
                          borderTopRightRadius: 0,
                          borderBottomRightRadius: 0
                        }}
                      />
                    }
                  />
                </div>
              </div>
            </div>
          </div>}     
            </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            onClick={() => {
              setshowCaseEvent({
                showPop: false,
                show: "",
                caseEventId: ""
              });
            }}
          >
            <i className="fa fa-reply"> Cancel </i>
          </button>
          <button
            className="btn btn-success ml-2"
            onClick={() => {
              setShowConfirm({ showPop: true, part: "Event" });
            }}
          >
            <i className="fa fa-floppy-o"> Save</i>
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Add/Edit Case Event */}

      {/* Madal Add/Edit Case Official Number */}
      <Modal
        show={showCaseOfficialNumber.showPop}
        onHide={() => {
          setShowCaseOfficialNumber({
            showPop: false,
            show: "",
            caseOfficialNumberId: ""
          });
        }}
        centered
        dialogClassName="modal-w"
      >
        <Modal.Header closeButton>
          {showCaseOfficialNumber.show === "Add" && (
            <Modal.Title>Add Case Official Number</Modal.Title>
          )}
          {showCaseOfficialNumber.show === "Edit" && (
            <Modal.Title>Edit Case Official Number</Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          <div className="form-group col labelPadRight">
            <Alerts />
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Type :
              </label>
              <div className="col-md-9">
                <Select
                  name="caseOfficialNumberType"
                  value={{
                    value: officialNumberFormData.OfficialNumberTypeId || 0,
                    label:
                      officialNumberFormData.caseOfficialNumberType ||
                      "Please Select"
                  }}
                  options={officenumbertypeDdl}
                  onChange={e => {
                    setOfficialNumberFormData({
                      ...officialNumberFormData,
                      officialNumberTypeId: e.value,
                      caseOfficialNumberType: e.label
                    });
                  }}
                />
              </div>
            </div>
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Official No :
              </label>
              <div className="input-group col-md-9">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="officialNo"
                  value={officialNumberFormData.officialNo}
                  onChange={e => {
                    setOfficialNumberFormData({
                      ...officialNumberFormData,
                      officialNo: e.target.value
                    });
                  }}
                />
              </div>
            </div>
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Date In Force :
              </label>
              <div className="col-md-9">
                <div className="input-group">
                  <DatePicker
                    dateFormat="yyyy/MM/dd"
                    placeholderText="date in force"
                    selected={officialNumberFormData.dateInForce}
                    onChange={date => {
                      setOfficialNumberFormData({
                        ...officialNumberFormData,
                        dateInForce: date
                      });
                    }}
                    customInput={
                      <input
                        className="form-control  form-control-sm"
                        style={{
                          borderTopRightRadius: 0,
                          borderBottomRightRadius: 0
                        }}
                      />
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            onClick={() => {
              setShowCaseOfficialNumber({
                showPop: false,
                show: "",
                caseOfficialNumberId: ""
              });
            }}
          >
            <i className="fa fa-reply"> Cancel </i>
          </button>
          <button
            className="btn btn-success ml-2"
            onClick={() => {
              setShowConfirm({ showPop: true, part: "OfficialNumber" });
            }}
          >
            <i className="fa fa-floppy-o"> Save</i>
          </button>
        </Modal.Footer>
      </Modal>
      {/* Madal Add/Edit Case Official Number */}

      {/* Modal Add/Edit Case Document */}
      <Modal
        show={showCaseDocument.showPop}
        onHide={() => {
          setShowCaseDocument({ showPop: false, show: "", caseDocumentId: "" });
        }}
        centered
        dialogClassName="modal-w"
      >
        <form encType="multipart/form-data" onSubmit={onDocumentSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add Case Documents</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group col labelPadRight">
              <Alerts />
              <div className="form-group row col">
                <label className="col-md-3 col-form-label form-control-sm sbold">
                  File:
                </label>
                <div className="input-group col-md-9">
                  <input
                    type="file"
                    name="document"
                    onChange={getDocumentSelect}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-danger ml-2"
              onClick={() => {
                setShowCaseDocument({
                  showPop: false,
                  show: "",
                  caseDocumentId: ""
                });
              }}
            >
              <i className="fa fa-reply"> Cancel </i>
            </button>
            <button className="btn btn-success ml-2">
              <i className="fa fa-floppy-o"> Save</i>
            </button>
          </Modal.Footer>
        </form>
      </Modal>
      {/* Modal Add/Edit Case Document */}

      {/* Modal Add/Edit Related Cases */}
      <Modal
        show={showRelatedCase}
        onHide={() => {
          setShowRelatedCase(false);
        }}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Related Cases</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card border-secondary">
            <h5 className="card-header text-white bg-primary"><i className="fa fa-search"></i> Search</h5>
            <div className="card-body">
              <div className="row">
                <div className="col-md-2">
                  <label className="title control-label">Case Title : </label>
                </div>
                <div className="col-md-10">
                    <input
                      type="search"
                      className="form-control"
                      value={RelateSearchFormData.title}
                      onChange={ e => setRelateSearchFormData({
                        ...RelateSearchFormData, title : e.target.value
                      })}
                    />
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <label className="title control-label">Case Reference</label>
                  <input
                    type="search"
                    className="form-control"
                    value={RelateSearchFormData.caseReference}
                    onChange={ e => setRelateSearchFormData({
                      ...RelateSearchFormData, caseReference : e.target.value
                    })}
                  />
                </div>
                <div className="col-md-3">
                  <label className="title control-label">Case Type</label>
                    <Select 
                      value={{
                        value: RelateSearchFormData.caseType.value,
                        label: RelateSearchFormData.caseType.label
                      }}
                      options={[{ value: 0, label: "Select All" } , ...caseTypeDdl]}
                      onChange={e => { setRelateSearchFormData({
                        ...RelateSearchFormData,
                        caseType : { value: e.value, label: e.label }
                      })}}
                    />
                </div>
                <div className="col-md-3">
                  <label className="title control-label">Basis</label>
                    <Select 
                      value={{
                        value: RelateSearchFormData.basis.value,
                        label: RelateSearchFormData.basis.label
                      }}
                      options={[{ value: 0, label: "Select All" } , ...basisDdl]}
                      onChange={e => { setRelateSearchFormData({
                        ...RelateSearchFormData,
                        basis : { value: e.value, label: e.label }
                      })}}
                    />
                </div>
                <div className="col-md-3">
                  <label className="title control-label">Type of Mark</label>
                    <Select 
                      value={{
                        value: RelateSearchFormData.typeOfMark.value,
                        label: RelateSearchFormData.typeOfMark.label
                      }}
                      options={[{ value: 0, label: "Select All" } , ...typeOfMarkDdl]}
                      onChange={e => { setRelateSearchFormData({
                        ...RelateSearchFormData,
                        typeOfMark : { value: e.value, label: e.label }
                      })}}
                    />
                </div>
              </div>
            </div>
          </div>
          <div className="card-body text-right" style={{paddingBottom:"0px"}}>
            <button
              className="btn btn-danger ml-2"
              onClick={() => {
                setShowRelatedCase(false);
              }}
            >
              <i className="fa fa-reply"> Cancel </i>
            </button>
            <button
              className="btn btn-success ml-2"
              onClick={() => {
                setShowConfirm({ showPop: true, part: "RelatedCases" });
              }}
            >
              <i className="fa fa-floppy-o"> Save</i>
            </button>
          </div>
          <div className="table-responsive">
            <a href="#down" id="top" style={{position:"absolute", right:"0px", padding:"29px 31px 0 0", zIndex:"1"}}>
              <i className="fa fa-arrow-down" style={{color:"#c8c8c8"}}/>
            </a>
            <DataTable
              noHeader={true}
              pagination={true}
              columns={relatedColumn}
              data={caseForRelatedData}
              selectableRows
              paginationPerPage={50}
              paginationRowsPerPageOptions={[10, 20, 50, 100]}
              onSelectedRowsChange={selectRelateChange}
              selectableRowSelected={row => selectedRelateRows.includes(parseInt(row.CaseId, 10) )}
            />
            <a href="#top" id="down" style={{position:"absolute", right:"0px", padding:"0 31px"}}>
              <i className="fa fa-arrow-up" style={{color:"#c8c8c8"}}/>
            </a>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            onClick={() => {
              setShowRelatedCase(false);
            }}
          >
            <i className="fa fa-reply"> Cancel </i>
          </button>
          <button
            className="btn btn-success ml-2"
            onClick={() => {
              setShowConfirm({ showPop: true, part: "RelatedCases" });
            }}
          >
            <i className="fa fa-floppy-o"> Save</i>
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Add/Edit Related Cases */}

      {/* Modal Add/Edit Billable Cases */}
      <Modal
        show={showBillableCase}
        onHide={() => {
          setShowBillableCase(false);
        }}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Billable Cases</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card border-secondary">
            <h5 className="card-header text-white bg-primary"><i className="fa fa-search"></i> Search</h5>
            <div className="card-body">
              <div className="row">
                <div className="col-md-2">
                  <label className="title control-label">Case Title : </label>
                </div>
                <div className="col-md-10">
                    <input
                      type="search"
                      className="form-control"
                      value={BillableSearchFormData.title}
                      onChange={ e => setBillableSearchFormData({
                        ...BillableSearchFormData, title : e.target.value
                      })}
                    />
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <label className="title control-label">Case Reference</label>
                  <input
                    type="search"
                    className="form-control"
                    value={BillableSearchFormData.caseReference}
                    onChange={ e => setBillableSearchFormData({
                      ...BillableSearchFormData, caseReference : e.target.value
                    })}
                  />
                </div>
                <div className="col-md-3">
                  <label className="title control-label">Case Type</label>
                    <Select 
                      value={{
                        value: BillableSearchFormData.caseType.value,
                        label: BillableSearchFormData.caseType.label
                      }}
                      options={[{ value: 0, label: "Select All" } , ...caseTypeDdl]}
                      onChange={e => { setBillableSearchFormData({
                        ...BillableSearchFormData,
                        caseType : { value: e.value, label: e.label }
                      })}}
                    />
                </div>
                <div className="col-md-3">
                  <label className="title control-label">Basis</label>
                    <Select 
                      value={{
                        value: BillableSearchFormData.basis.value,
                        label: BillableSearchFormData.basis.label
                      }}
                      options={[{ value: 0, label: "Select All" } , ...basisDdl]}
                      onChange={e => { setBillableSearchFormData({
                        ...BillableSearchFormData,
                        basis : { value: e.value, label: e.label }
                      })}}
                    />
                </div>
                <div className="col-md-3">
                  <label className="title control-label">Type of Mark</label>
                    <Select 
                      value={{
                        value: BillableSearchFormData.typeOfMark.value,
                        label: BillableSearchFormData.typeOfMark.label
                      }}
                      options={[{ value: 0, label: "Select All" } , ...typeOfMarkDdl]}
                      onChange={e => { setBillableSearchFormData({
                        ...BillableSearchFormData,
                        typeOfMark : { value: e.value, label: e.label }
                      })}}
                    />
                </div>
              </div>
            </div>
          </div>
          <div className="card-body text-right" style={{paddingBottom:"0px"}}>
            <button
              className="btn btn-danger ml-2"
              onClick={() => {
                setShowBillableCase(false);
              }}
            >
              <i className="fa fa-reply"> Cancel </i>
            </button>
            <button
              className="btn btn-success ml-2"
              onClick={() => {
                setShowConfirm({ showPop: true, part: "BillableCases" });
              }}
            >
              <i className="fa fa-floppy-o"> Save</i>
            </button>
          </div>
          <div className="table-responsive">
            <a href="#down" id="top" style={{position:"absolute", right:"0px", padding:"29px 31px 0 0", zIndex:"1"}}>
              <i className="fa fa-arrow-down" style={{color:"#c8c8c8"}}/>
            </a>
            {/*
            <div>selectedBillableRows IDs: {selectedBillableRows.join(', ')}</div>
            */}
            <div>
              {selectedBillList!='0:null' && selectedBillList.length > 0 && selectedBillList.map((id) => (
                <div key={id} 
                  style={{ display: 'inline-block', margin: '5px', padding: '5px', border: '1px solid #ddd', borderRadius: '5px' }}>
                  {id.split(':')[1]}
                  <button hidden={!pagePermission.IsDelete} onClick={() => removeTag(id)} style={{ marginLeft: '5px', color: 'red' }}>X</button>
                </div>
              ))}
            </div>
            <DataTable
              noHeader={true}
              pagination={true}
              columns={billableColumn}
              data={caseForBillableData}
              selectableRows={false}
              paginationPerPage={50}
              paginationRowsPerPageOptions={[10, 20, 50, 100]}
              onSelectedRowsChange={selectBillableChange}
              selectableRowSelected={isRowSelected}
              //selectableRowSelected={row => selectedBillableRows.includes(parseInt(row.CaseId, 10) )}

            />
            

            <a href="#top" id="down" style={{position:"absolute", right:"0px", padding:"0 31px"}}>
              <i className="fa fa-arrow-up" style={{color:"#c8c8c8"}}/>
            </a>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            onClick={() => {
              setShowBillableCase(false);
            }}
          >
            <i className="fa fa-reply"> Cancel </i>
          </button>
          <button
            className="btn btn-success ml-2"
            onClick={() => {
              setShowConfirm({ showPop: true, part: "BillableCases" });
            }}
          >
            <i className="fa fa-floppy-o"> Save</i>
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Add/Edit Billable Cases */}

      {/* Modal Send Email*/}
      <Modal
        show={showEmail}
        onHide={() => setShowEmail(false)}
        centered
        size="lg"
      >
        
        <Modal.Header closeButton>
          <Modal.Title>Send Email</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group col labelPadRight" style={{paddingLeft:"25px"}}>
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                To :
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={sendEmailFormData.toTxt}
                  onChange={e => 
                    setSendEmailFormData({ ...sendEmailFormData, toTxt: e.target.value})
                  }
                />
              </div>
            </div>
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                CC :
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={sendEmailFormData.ccTxt}
                  onChange={ e => 
                    setSendEmailFormData({...sendEmailFormData, ccTxt: e.target.value})
                  }
                />
              </div>
            </div>
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                BCC :
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={sendEmailFormData.bccTxt}
                  onChange={ e => 
                    setSendEmailFormData({...sendEmailFormData, bccTxt: e.target.value})
                  }
                />
              </div>
            </div>
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Subject :
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={sendEmailFormData.subjectTxt}
                  onChange={ e => 
                    setSendEmailFormData({...sendEmailFormData, subjectTxt: e.target.value})
                  }
                />
              </div>
            </div>
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Body :
              </label>
            </div>
            <div className="form-group row col">
              <div className="input-group col-md-12"> 
                <ReactQuill 
                  modules={ {
                    toolbar: [
                      [{ 'font': Font.whitelist }],
                      [{ 'header': [1, 2, false] }],
                      ['bold', 'italic', 'underline','strike', 'blockquote'],
                      [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
                      [{ 'color': [] }, { 'background': [] }], 
                      ['link', 'image'],
                      ['clean']
                    ],
                  }}
                  value={sendEmailFormData.bodyTxt}
                  onChange={ e => 
                    setSendEmailFormData({...sendEmailFormData, bodyTxt: e })
                  }
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            onClick={() => setShowEmail(false)}
          >
            <i className="fa fa-reply"> Cancel </i>
          </button>
          <button
            className="btn btn-success ml-2"
            onClick={() => 
              setShowConfirm({ showPop: true, part: "SendEmail" })
            }
          >
            <i className="fa fa-paper-plane"> Send</i>
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Send Email*/}
    </Layout>
  );
};

export default CaseView;
